import {Component, Inject, OnInit, OnDestroy, HostListener } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DOCUMENT, LocationStrategy} from '@angular/common';
import CustomerLeadsModel, { LeadsExcelObj } from '../../../services/customerLead.model';
import {CustomerLeadService} from '../../../services/customerLead.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PersonsService} from '../../../services/persons.service';
import PersonsModel from '../../../services/persons.model';
import {BusinessEntityService} from '../../../services/businessEntity.service';
import { FarmSiteService } from 'src/app/services/farmSite.service';
import {ExcelService} from '../../../services/excelService';
import {CountriesService} from '../../../countries.service';
import { PreviousRouteService } from 'src/app/services/previousRouteService';
import { BatchLoader } from 'src/app/Utils/batch-loader.util';
import MarketConnectModel from 'src/app/services/market-connect.model';
import BusinessEntity from 'src/app/services/businessEntity.model';
import { MarketConnectService } from 'src/app/services/market-connect.service';
import { ToastrService } from 'ngx-toastr';

declare const CanvasJS: any;
declare var $: any;

/**
  * Component Represents for managing Market connect leads data.
  * This component provides functionality to handle Market connect leads data, display them in a list,
  * and interact with their data through forms and UI elements.
  * @module MarketConnectComponent
  */

@Component({
  selector: 'app-market-connect',
  templateUrl: './market-connect.component.html',
  styleUrls: ['./market-connect.component.css']
})

export class MarketConnectComponent implements OnInit, OnDestroy {

  public marketConnects!: Array<MarketConnectModel>;
  public customerLeads!: Array<CustomerLeadsModel>;
  public leadsExcelObj!: LeadsExcelObj;
  public loginPersonType!: string;
  public LoginUserName!: string;
  public loginUserBusinessName!: string;
  // pagination sorting
  public currentpagenum = 1;
  public noofitemsPerPage = 6;
  public hatcheryActivePageNo!: number;
  /*marjet connect*/
  public marketcurrentpagenum = 1;
  public marketnoofitemsPerPage = 6;
  public marketActivePageNo!: number;
  /*farms pagination*/
  public farmscurrentpagenum = 1;
  public farmsnoofitemsPerPage = 6;
  public farmsActivePageNo!: number;
  /*Buyers pagination*/
  public buyercurrentpagenum = 1;
  public buyernoofitemsPerPage = 6;
  public buyerActivePageNo!: number;
  public showHatcheryDetails!: boolean;
  public hatcheryResponseLoader!: boolean;
  public showMarketConnectDetails!: boolean;
  public showMarketConnectTrends!: boolean;
  public showFarmsDetails!: boolean;
  public FarmsResponseLoader!: boolean;
  public showBuyersDetails!: boolean;
  public buyerResponseLoader!: boolean;
  public shrimpData: any[] = [];
  public fishData: any[] = [];
  public totalData: any[] = [];
  public weekfromDate!: string;
  public monthfromDate!: string;
  public yearfromDate!: string;
  public todayDate!: string;
  public noOfDays!: string;
  public filteredData!: any [];
  public tablefilteredData!: any [];
  public culturetype!: string;
  public hatcheryRegistred = 0;
  public demoRequest = 0;
  public seedPosted = 0;
  public leadReceived = 0;
  public bluHatchLeads = 0;
  public bluHatchLeadsConverted = 0;
  public blubayLeads = 0;
  public blubayLeadsConverted = 0;
  public farmsRegistred = 0;
  public farmsDemoRequests = 0;
  public farmsSeedRequest = 0;
  public farmsQuoteRequest = 0;
  public farmsStockLeads = 0;
  public buyersRegistred = 0;
  public buyersDemoRequests = 0;
  public buyersStockRequest = 0;
  public buyerLeadsRequest = 0;
  public tablenoOfDays!: string;
  public tableculturetype!: string;
  public tableSelectionKey!: any;
  public finalData!: any [];
  public hatcherySearch!: string;
  public marketConnectSearch!: string;
  public farmSearch!: string;
  public buyerSearch!: string;
  public marketconnecttableculturetype!: string;
  public marketconnecttablenoOfDays!: string;
  public marketconnecttablefilteredData!: any;
  public marketconnecttableSelectionKey!: string;
  public marketconnectfinalData!: any[];
  public marketConnectCustomerLeads!: Array<CustomerLeadsModel & {
    businessId?: string | number;
    businessName?: string;
    farmSiteName?: string;
    name?: string;
    dialingCode?: string;
  }>;
  /*market connect graph*/
  public marketconnecttableGraphculturetype!: string;
  public marketconnecttableGraphnoOfDays!: string;
  public marketconnecttableGraphSelectionKey!: string;
  public marketConnectgraphfilteredData = new Array();
  public marketConnectGraph!: Array<MarketConnectModel>;
  public finalLeads = new Array();
  public farmscustomerLeads!: Array<CustomerLeadsModel>;
  public farmstableculturetype!: string;
  public farmstablenoOfDays!: string;
  public farmstableSelectionKey!: string;
  public farmstablefilteredData!: any[];
  public farmsfinalData!: any[];
  public buyerscustomerLeads!: Array<CustomerLeadsModel>;
  public buyertableculturetype!: string;
  public buyertablenoOfDays!: string;
  public buyertableSelectionKey!: string;
  public buyertablefilteredData!: any[];
  public buyerfinalData!: any[];
  public mcAnalyticsSummaryData!: any;
  public analyticsEventsArray = new Array();
  public analyticsUsersArray = new Array();
  public analyticsnoOfDays!: string;
  public analyticsCulturetype!: string;
  public analyticsSelectionKey!: string;
  public showGoogleAnalytics!: boolean;
  public analyticsfinalData = new Array();
  public analyticscurrentpagenum = 1;
  public analyticsnoofitemsPerPage = 10;
  /*follow up*/
  public followupSubmitted!: boolean;
  public followupForm: FormGroup;
  public customerLead: CustomerLeadsModel & {
    status_remarks?: string;
    assigned_to?: { id: string | number; name: string };
  };
  public mobileNumber!: string;
  public currentDate!: string;
  public selectedItem: any;
  /*close*/
  public closeSubmitted!: boolean;
  public closeForm: FormGroup;
  /*assign*/
  public persons!: Array<PersonsModel>;
  public person!: PersonsModel;
  public assignedId?: string;
  public assignedSubmitted!: boolean;
  public assignedForm: FormGroup;
  public businessEntities!: Array<BusinessEntity>;
  public businessEntity!: BusinessEntity | undefined;
  public dispFinalData: any;
  public dispmarketconnectfinalData: any;
  public dispfarmsfinalData: any;
  public dispbuyerfinalData: any;
  public hatcheryName!: boolean;
  public farmName!: boolean;
  public buyerLocationName!: boolean;
  public selectedIndex: any;
  public selectedcard!: string;
  public yesterDayDate!: string;
  public lastMonthEndDate!: string;
  public lastMonthStartDate!: string;
  public lastWeekDate!: string;
  public lastYearEndDate!: string;
  public lastYearStartDate!: string;
  public incrementDecrementCount!: any[];
  public blubayLeadsConvertedCount!: number;
  public blubayLeadsRegistredCount!: number;
  public hatcheryLeadsConvertedCount!: number;
  public hatcheryLeadRegistredCount!: number;
  public incrementHatcheryRegister = 0;
  public incrementHatcheryDemoReq = 0;
  public incrementHatcherySeed = 0;
  public incrementHatcheryLeed = 0;
  public incrementFarmRegister = 0;
  public incrementFarmDemoReq = 0;
  public incrementFarmSeed = 0;
  public incrementFarmLeed = 0;
  public incrementFarmsStockLeads = 0;
  public incrementBuyerRegister = 0;
  public incrementBuyerDemoReq = 0;
  public incrementBuyerStock = 0;
  public incrementBuyerLeed = 0;
  public shrimpIncrementDecrement!: any[];
  public totalIncrementDecrement!: any[];
  public fishIncrementDecrement!: any[];
  public selectedEvent!: string;
  public dataPoints: any;
  public dataPoints2!: any[];
  public rangeButtonIndex!:number;
  public dateRange = new Array();
  public cultureCategoryId: any;
  public clearHatcherySearchInput!: boolean;
  public clearMCSearchInput!: boolean;
  public clearFarmSearchInput!: boolean;
  public clearBuyerSearchInput!: boolean;
  public displayHatcherySite!: boolean;
  public countries: any;
  public responseLoader!: boolean;
  customFromDate!: string;
  customToDate!: string;
  public isDateRangePopupOpen: boolean = false;
  customHatcheryFromDate!: string;
  customHatcheryToDate!: string;
  public isHatcheryDateRangePopupOpen: boolean = false;
  customMCFromDate!: string;
  customMCToDate!: string;
  public isMCDateRangePopupOpen: boolean = false;
  customMCREPFromDate!: string;
  customMCREPToDate!: string;
  isMCREPDateRangePopupOpen!: boolean;
  customFarmsFromDate!: string;
  customFarmsToDate!: string;
  isFarmsDateRangePopupOpen!: boolean;
  customBuyerFromDate!: string;
  customBuyerToDate!: string;
  isBuyerDateRangePopupOpen!: boolean;

  public listLoader = false;              // Show listLoader spinner
  public isFiltering: boolean = false;
  public noList: boolean = false;
  private batchLoader!: BatchLoader<any>;

  /**
    * Constructor of the component.
    *
    * @param {any} document - The global document object.
    * @param {ExcelService} excelService - The service for Excel functionality.
    * @param {FarmSiteService} farmsiteService - The service for farm site data.
    * @param {BusinessEntityService} businessEntityService - The service for business entities.
    * @param {PersonsService} personsService - The service for person data.
    * @param {ActivatedRoute} route - The current route information.
    * @param {FormBuilder} formBuilder - The FormBuilder for creating forms.
    * @param {MarketConnectService} marketConnectService - The service for market connect data.
    * @param {CustomerLeadService} customerLeadService - The service for customer leads.
    */
  constructor(@Inject(DOCUMENT) private document: any, public countryService: CountriesService, public excelService: ExcelService, public farmsiteService: FarmSiteService, public businessEntityService: BusinessEntityService, public personsService: PersonsService, public route: ActivatedRoute, public formBuilder: FormBuilder, public marketConnectService: MarketConnectService, public customerLeadService: CustomerLeadService,
  private locationStrategy: LocationStrategy, private previousRouteService: PreviousRouteService, public toastr: ToastrService) {
    /**
     * Initializing a new customer lead  model.
     * This will be used to store the data for the current customer lead.
     */
    this.customerLead = new CustomerLeadsModel();
    /**
      * Initializing lead followup for validation.
      * This FormGroup represents the form controls for the lead followup.
      * @type {FormGroup}
      * @type {FormControl}
      */
    this.followupForm = this.formBuilder.group({
      description: ['', [Validators.required,
        Validators.minLength(3),
        Validators.maxLength(200)]]
    });
    /**
      * Initializing close form for validation.
      * This FormGroup represents the form controls for the close lead.
      * @type {FormGroup}
      * @type {FormControl}
      */
    this.closeForm = this.formBuilder.group({
      convert: [null],
      closedescription: ['', [Validators.required,
        Validators.minLength(3),
        Validators.maxLength(200)]]
    });
    /**
      * Initializing assign form for validation.
      * This FormGroup represents the form controls for the assign person.
      * @type {FormGroup}
      * @type {FormControl}
      */
    this.assignedForm = this.formBuilder.group({
      businessid: ['', [Validators.required]]
    });
  }

  /**
    * @async
    * @method
    * @throws {Error} If there's an error during initialization.
    * @returns {Promise<void>} A Promise that resolves when the initialization is completed or rejects if an error occurs.
    * Description:
    * 1. When the page loads, this function is triggered.
    * 2. It prepares the page and loads market connects, businesses data by calling getMarketConnectCountsByDate and getAllBusinessEntity methods
    * which is in the {@link MarketConnectService} and {@link BusinessEntityService} file.
    */
  public async ngOnInit(): Promise<void> {
    try {
      window.scrollTo(0, 0);
      this.loginPersonType = localStorage.getItem('loginPersonType') || '';
      this.LoginUserName = localStorage.getItem('LoginUserName') || '';
      this.loginUserBusinessName = localStorage.getItem('loginBusinessName') || '';
      this.previousRouteService.setPreviousRoute(this.locationStrategy.path()); // To store the Previous route
      /* user login details end */
      this.showHatcheryDetails = false;
      this.showMarketConnectDetails = false;
      this.showMarketConnectTrends = false;
      this.showGoogleAnalytics = false;
      this.showFarmsDetails = false;
      this.showBuyersDetails = false;
      this.responseLoader = false;
      let date = moment(new Date()).format('YYYY-MM-DD');
      this.marketConnects = await this.marketConnectService.getMarketConnectCountsByDate(date);
      this.businessEntities = await this.businessEntityService.getAllBusinessEntity();
      this.businessEntity = this.businessEntities.find(business => business.businessName == this.loginUserBusinessName);
      this.initDates();
      this.noOfDays = 'today';
      this.culturetype = 'total';
      this.selectedDate('today');
      this.makeData('total');
      this.changeColor('total');
      this.hatcheryName = true;
      this.farmName = false;
      this.countries = await this.countryService.ngOnInit();
    } catch (error: any) {
      this.toastr.error(error.error?.message || error)
    }
  }

  /**
    * @method
    * @returns {void} This function does not return a value.
    * Description:
    * This function cancels any ongoing HTTP requests made by the marketConnectService, businessEntityService and customerLeadService
    * when the component is being destroyed, preventing potential memory leaks or unexpected behavior.
    * This can be achieved by calling cancelOnGoingHttpRequests method which is in the {@link MarketConnectService}, {@link BusinessEntityService} and {@link CustomerLeadService} file.
    */
  public ngOnDestroy(): void {
    this.marketConnectService.cancelOnGoingHttpRequests();
    this.businessEntityService.cancelOnGoingHttpRequests();
    this.customerLeadService.cancelOnGoingHttpRequests();
    this.marketConnectService.cancelOnGoingHttpRequests();
    this.batchLoader?.markAsDestroyed();
    this.batchLoader?.reset();
  }

  /**
    * @method
    * @param {Array} dataPoints - Data points for the 'Leads' series.
    * @param {Array} dataPoints2 - Data points for the 'Converted' series.
    * Description:
    * This method is used to Creates and renders a CanvasJS stock chart with the specified data points.
    */
  public marketConnectChart(dataPoints: Array<any>,dataPoints2: Array<any>): void {
    let stockChart = new CanvasJS.StockChart('chartContainer', {
      charts: [{
        axisX:{
          title:'Timeline',
          titleWrap:true,
          titleMaxWidth:200,
          titleFontColor:'#5A5F7D',
          titleFontFamily:'Inter',
          labelFontColor: "#868EAE",
          labelFontSize:16,
          labelWrap: true,
          labelAutoFit: true,
          labelTextAlign: "center",
          labelMaxWidth:200,
          labelFontFamily:'Inter',
          lineColor: "#E3E6EF",
          lineThickness:3,
          titleFontSize:22,
          labelFormatter: function (e: any) {
            return CanvasJS.formatDate( e.value, "DD MMM YYYY");
          },
        },
        axisY: {
          title: 'Value',
          titleWrap:true,
          titleMaxWidth:200,
          titleFontColor:'#5A5F7D',
          titleFontFamily:'Inter',
          labelFontColor: "#868EAE",
          labelFontFamily:'Inter',
          labelFontSize: 20,
          labelWrap: true,
          labelAutoFit: true,
          labelTextAlign: "center",
          labelMaxWidth: 200,
          gridDashType: "dot",
			    gridThickness: 2,
          gridColor: "#E3E6EF",
          lineColor: "white",
          tickColor: "white",
          tickThickness:0,
          titleFontSize:22,
          margin: 10,
        },
        legend:{
          fontSize:17,
          fontFamily:'Inter Regular',
          fontWeight:'bold',
          fontColor:'#5A5F7D',
          verticalAlign:'top',
          horizontalAlign:'center',
          markerMargin:10,
          itemWrap:true,
          cursor:'pointer'
        },
        data: [{
          type: 'column',
          name:'Leads',
          color: "#95CCFD",
		      markerSize:15,
          markerColor:'#95CCFD',
          markerType:"circle",
          legendText: 'Leads',
          legendMarkerType: 'circle',
          showInLegend: true,
          dataPoints: dataPoints,
          highlightEnabled: true,
          connectNullData: true,
          lineColor:'blue',
          fillOpacity:1,
          cursor:'pointer',
          toolTipContent: "{x}<br>{name} : {y}",
          intervalType:'month || year || all'
        }, {
          type: 'column',
          name:'Converted',
          color:'#8FE4CB',
		      markerSize:15,
          markerColor:'#20C997',
          markerType:"circle",
          legendText: 'Converted',
          legendMarkerType: 'circle',
          showInLegend: true,
          dataPoints: dataPoints2,
          highlightEnabled: true,
          connectNullData: true,
          lineColor:'green',
          cursor:'pointer',
          toolTipContent: "{x}<br>{name} : {y}",
          interval:15,
          intervalType:'month || year || all'
          }]
        }],
      rangeSelector: {
        enabled:false,
        label:'',
        buttons: [
           {
            range:1,
            rangeType: 'day',
            label: '',
          },
          {
            range:1,
            rangeType: 'week',
            label: ''
          },
          {
            range:1,
            rangeType:"month",
            label:"",
          },
          {
            range:1,
            rangeType: 'year',
            label: ''
          },
        {
          rangeType:'all',
          label:''
        }],
        buttonStyle:{
         borderColor:'white',
         labelFontColor:'white',
         backgroundColorOnSelect:'white'
        },
        inputFields: {
          enabled:false,
        },
      selectedRangeButtonIndex:this.rangeButtonIndex,
      },
      navigator: {
        enabled:true,
        height:100,
      },
    });
    stockChart.render();
  }

  /**
    * @method
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Retrieves and displays hatchery details. Sets flags, retrieves customer leads data, and initializes table data and filters.
    */
  public async getHatcheryDetails(): Promise<void> {
    try {
      this.showBuyersDetails = false;
      this.showFarmsDetails = false;
      this.showMarketConnectTrends = false;
      this.showMarketConnectDetails = false;
      this.showGoogleAnalytics = false;
      this.clearHatcherySearchInput = false;
      this.hatcherySearch = '';
      this.showHatcheryDetails = true;
      // this.swapTable('hatcheryreport');
      this.hatcheryResponseLoader = true;
      let hatchery = await this.customerLeadService.getAllCustomerLeads();
      this.customerLeads = hatchery.filter(itemtype => itemtype.status == 'Open' || itemtype.status == 'FollowUp' || itemtype.status == 'Assigned');
      this.hatcheryResponseLoader = false;
      this.tableculturetype = 'total';
      this.tablenoOfDays = 'today';
      this.tableSelectionKey = 'Hatchery';
      this.tableDays('today');
      this.tablemakeData('total', 'Hatchery');
      this.addBoxSahadow('total');
      this.cultureCategoryId = 'All';
    } catch (error: any) {
      this.toastr.error(error.error?.message || error)
      this.hatcheryResponseLoader = false;
    }
  }

  /**
    * @method
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Retrieves and displays market connect details. Sets flags, retrieves customer leads data, initializes table data and filters, and associates business and farm site details.
    */
  public async getMarketConnectDetails(): Promise<void> {
    try {
      this.showBuyersDetails = false;
      this.showFarmsDetails = false;
      this.showMarketConnectTrends = false;
      this.showHatcheryDetails = false;
      this.showGoogleAnalytics = false;
      this.clearMCSearchInput = false;
      this.marketConnectSearch = '';
      this.showMarketConnectDetails = true;
      // this.swapTable('marketreport');
      this.finalLeads = [];
      this.responseLoader = true;
      const marketConnectCustomerLeads = await this.customerLeadService.getAllCustomerLeads();
      this.marketConnectCustomerLeads = (marketConnectCustomerLeads.filter(
        (itemtype: CustomerLeadsModel) => itemtype.status === 'Open' || itemtype.status === 'FollowUp' || itemtype.status === 'Assigned'
      ) as Array<CustomerLeadsModel & {
        businessId?: string | number;
        businessName?: string;
        farmSiteName?: string;
        name?: string;
        dialingCode?: string;
      }>);
      this.marketConnectCustomerLeads.forEach((lead) => {
        const matchedCountry = this.countries.find(
          (country: any) => country.dialCode === lead.dialingCode
        );
        if (matchedCountry) {
          lead.name = matchedCountry.name;
        }
      });
      let business = await this.businessEntityService.getAllBusinessEntity();
      let farmsites = await this.farmsiteService.getAllFarmSites();
      this.responseLoader = false;
      // let trailBusiness = _.filter(business, {'status': 'trial'}); // as discussed with jagadeesh comment this line because
      let trailBusiness = business;
      for (let a = 0; a < trailBusiness.length; a++) {
        let eachBusiness = trailBusiness[a];
        for (let b = 0; b < this.marketConnectCustomerLeads.length; b++) {
          let eachLead = this.marketConnectCustomerLeads[b];
          if (eachLead.mobileNumber == eachBusiness.mobileNumber) {
            this.marketConnectCustomerLeads[b].businessId = eachBusiness.id;
            this.marketConnectCustomerLeads[b].businessName = eachBusiness.businessName;
            for(let k = 0; k < farmsites.length; k++){
              if(eachBusiness.id == farmsites[k].businessID){
                this.marketConnectCustomerLeads[b].farmSiteName = farmsites[k].farmNameAtLocation;
              }
            }
          }
        }
      }
      this.marketconnecttableculturetype = 'total';
      this.marketconnecttablenoOfDays = 'today';
      this.marketconnecttableSelectionKey = 'Farm';
      this.marketconnecttableDays('today');
      this.marketConnectTableMakeData('total', 'Farm');
      this.addBoxSahadow('total');
      this.cultureCategoryId = 'All';
    } catch (error: any) {
      this.responseLoader = false;
      this.toastr.error(error.error?.message || error)
    }
  }

  async getPersonDetails(mobileNumber: string): Promise<void> {
    this.person = await this.personsService.getPersonByMobileNumber(mobileNumber);
    if (Array.isArray(this.person) && this.person.length > 0) {
      this.person = this.person[0];
    }
    $('#myModal').modal('show');
  }

  /**
    * @method
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Retrieves and displays market connect trends. Sets flags, retrieves graph data, and initializes table graph data and filters.
    */
  public async getMarketConnectTrends(): Promise<void> {
    try {
      this.showMarketConnectTrends = true;
      this.showBuyersDetails = false;
      this.showFarmsDetails = false;
      this.showMarketConnectDetails = false;
      this.showHatcheryDetails = false;
      this.showGoogleAnalytics = false;
      this.marketConnectGraph = await this.marketConnectService.getMarketConnectGraphData();
      this.marketconnecttableGraphculturetype = 'total';
      this.marketconnecttableGraphnoOfDays = 'today';
      this.marketconnecttableGraphSelectionKey = 'Farm';
      this.marketconnecttableGraphDays('today');
      this.marketConnectTableGraphMakeData('total', 'Farm');
      this.cultureCategoryId = 'All';
    } catch (error: any) {
      console.error('Error fetching market connect trends:', error);
      this.toastr.error(error.error?.message || error)
    }
  }

  /**
    * @method
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Retrieves and displays Google Analytics data. Initializes flags, filters, and table data to display real-time event data from Google Analytics.
    */
  public async googleAnalytics(): Promise<void> {
    this.showGoogleAnalytics = true;
    this.analyticsnoOfDays = 'today';
    this.analyticsCulturetype = 'total';
    this.analyticsSelectionKey = 'Farm';
    this.analyticsDays('today');
    this.analyticsMakeData('total', 'Farm');
  }

  /**
    * @method
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Retrieves and displays details for farms. Clears search input, sets flags, and initializes table data and filters.
    */
  public async getFarmsDetails(): Promise<void> {
    try {
      this.showBuyersDetails = false;
      this.showHatcheryDetails = false;
      this.showMarketConnectTrends = false;
      this.showMarketConnectDetails = false;
      this.showGoogleAnalytics = false;
      this.clearFarmSearchInput = false;
      this.farmSearch = '';
      this.showFarmsDetails = true;
      // this.swapTable('farmsreport');
      this.FarmsResponseLoader = true;
      let farmscustomerLeads = await this.customerLeadService.getAllCustomerLeads();
      this.farmscustomerLeads = farmscustomerLeads.filter(itemtype => itemtype.status == 'Open' || itemtype.status == 'FollowUp' || itemtype.status == 'Assigned');
      this.FarmsResponseLoader = false;
      this.farmstableculturetype = 'total';
      this.farmstablenoOfDays = 'today';
      this.farmstableSelectionKey = 'Farm';
      this.farmstableDays('today');
      this.farmsTableMakeData('total', 'Farm');
      this.farmsaddBoxSahadow('total');
      this.cultureCategoryId = 'All';
    } catch (error: any) {
      this.FarmsResponseLoader = false;
      this.toastr.error(error.error?.message || error)
    }
  }

  /**
   * @method
   * @returns {void} This function does not return a value.
   * Description:
   * This method is used to Retrieves and displays details for buyers. Clears search input, sets flags, and initializes table data and filters.
   */
  public async getBuyersDetails(): Promise<void> {
    try {
      this.showHatcheryDetails = false;
      this.showFarmsDetails = false;
      this.showMarketConnectTrends = false;
      this.showMarketConnectDetails = false;
      this.showGoogleAnalytics = false;
      this.clearBuyerSearchInput = false;
      this.buyerSearch = '';
      this.showBuyersDetails = true;
      // this.swapTable('buyerreport');
      this.buyerResponseLoader = true;
      let buyerscustomerLeads = await this.customerLeadService.getAllCustomerLeads();
      this.buyerResponseLoader = false;
      this.buyerscustomerLeads = buyerscustomerLeads.filter(itemtype => itemtype.status == 'Open' || itemtype.status == 'FollowUp' || itemtype.status == 'Assigned');
      this.buyertableculturetype = 'total';
      this.buyertablenoOfDays = 'today';
      this.buyertableSelectionKey = 'Buyer';
      this.buyerstableDays('today');
      this.buyerTableMakeData('total', 'Buyer');
      this.farmsaddBoxSahadow('total');
      this.cultureCategoryId = 'All';
    } catch (error: any) {
      this.buyerResponseLoader = false;
      this.toastr.error(error.error?.message || error)
    }
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    this.checkScrollAndLoad();
  }

  private scrollTimeout: any;
  private checkScrollAndLoad(): void {
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100 &&
          !this.batchLoader?.isLoading() && !this.isFiltering) {
        this.batchLoader?.loadNextBatch();
      }
    }, 50);
  }

  private initializeBatchLoader(): void {
    this.batchLoader = new BatchLoader<any>(
      () => {
        switch (true) {
          case this.showBuyersDetails:
            return this.buyerfinalData;
          case this.showHatcheryDetails:
            return this.finalData;
          case this.showFarmsDetails:
            return this.farmsfinalData;
          case this.showMarketConnectDetails:
            return this.marketconnectfinalData;
          default:
            return []; // fallback
        }
      },
      (updatedList) => {
        switch (true) {
          case this.showBuyersDetails:
            this.dispbuyerfinalData = updatedList;
            break;
          case this.showFarmsDetails:
            this.dispfarmsfinalData = updatedList;
            break;
          case this.showHatcheryDetails:
            this.dispFinalData = updatedList;
          case this.showMarketConnectDetails:
            this.dispmarketconnectfinalData = updatedList;
            break;
        }
        this.noList = updatedList.length === 0;
      },
      undefined,
      (loading) => this.listLoader = loading
    );
  }

  /**
    * @method
    * @param {string} type - The type of table or section to close.
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Closes the specified table or section based on the provided type.
    */
  public closeTable(type: string): void {
    if (type == 'marketconnect') {
      this.showMarketConnectDetails = false;
    } else if (type == 'hatcheriesdetails') {
      this.showHatcheryDetails = false;
    } else if (type == 'farmsdetails') {
      this.showFarmsDetails = false;
    } else if (type == 'marketconnectgraph') {
      this.showMarketConnectTrends = false;
    }else if(type == 'closegoogleanalytics'){
      this.analyticsfinalData = [];
      this.showGoogleAnalytics = false;
    } else {
      this.showBuyersDetails = false;
    }
    this.cultureCategoryId = undefined;
  }

  /**
    * @method
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Initializes various date values for different time ranges. Sets the values for the current day, yesterday, last week, last month, and last year.
    */
  public initDates(): any {
    let date = new Date();
    date.setDate(date.getDate() - 7);
    this.weekfromDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    date = new Date();
    date.setDate(date.getDate() - 1);
    let yesterDay = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.yesterDayDate = (moment(yesterDay).format('YYYY-MM-DD')).toString();
    date = new Date();
    date.setDate(date.getDate() - 30);
    this.monthfromDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

    date = new Date();
    date.setDate(date.getDate() - 365);
    this.yearfromDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

    date = new Date();
    this.todayDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

    date = new Date(this.weekfromDate);
    date.setDate(date.getDate() - 7);
    this.lastWeekDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

    this.lastMonthEndDate = moment(new Date()).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    this.lastMonthStartDate = moment(new Date()).subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
    /*last year*/
    this.lastYearEndDate = moment(new Date()).subtract(1, 'year').endOf('year').format('YYYY-MM-DD');
    this.lastYearStartDate = moment(new Date()).subtract(1, 'year').startOf('year').format('YYYY-MM-DD');
  }

  /**
    * @method
    * @param {string} val - The selected date option ('today', 'oneweek', 'onemonth', 'oneyear', etc.).
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Updates the selected date and triggers data retrieval and processing based on the selected date.
    */
  public selectedDate(val: string): void {
    this.noOfDays = val;
    // Reset custom date values when selecting predefined ranges
    if (val !== 'Custom') {
      this.customFromDate = '';
      this.customToDate = '';
    }
    // If 'Custom' is selected, open the date range popup
    if (val === 'Custom') {
      this.isDateRangePopupOpen = true;
    } else {
      this.getData(val);
    }
    if (this.filteredData.length > 0) {
      this.makeData(this.culturetype);
    } else {
      this.hatcheryRegistred = 0;
      this.demoRequest = 0;
      this.seedPosted = 0;
      this.leadReceived = 0;
      this.bluHatchLeads = 0;
      this.bluHatchLeadsConverted = 0;
      this.blubayLeads = 0;
      this.blubayLeadsConverted = 0;
      this.farmsRegistred = 0;
      this.farmsDemoRequests = 0;
      this.farmsSeedRequest = 0;
      this.farmsQuoteRequest = 0;
      this.farmsStockLeads = 0;
      this.buyersRegistred = 0;
      this.buyersDemoRequests = 0;
      this.buyersStockRequest = 0;
      this.buyerLeadsRequest = 0;
    }
    if (this.incrementDecrementCount.length > 0) {
      this.makeData(this.culturetype);
    } else {
      this.hatcheryLeadRegistredCount = 0;
      this.hatcheryLeadsConvertedCount = 0;
      this.blubayLeadsRegistredCount = 0;
      this.blubayLeadsConvertedCount = 0;
      this.incrementHatcheryRegister = 0;
      this.incrementHatcheryDemoReq = 0;
      this.incrementHatcherySeed = 0;
      this.incrementHatcheryLeed = 0;
      this.incrementFarmRegister = 0;
      this.incrementFarmDemoReq = 0;
      this.incrementFarmSeed = 0;
      this.incrementFarmLeed = 0;
      this.incrementFarmsStockLeads = 0;
      this.incrementBuyerRegister = 0;
      this.incrementBuyerDemoReq = 0;
      this.incrementBuyerStock = 0;
      this.incrementBuyerLeed = 0;
    }
  }

  openDateRangePopup() {
    this.isDateRangePopupOpen = true;
  }

  /**
    * @method
    * @param {string} type - The culture type ('shrimp', 'fish', 'total').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Processes and aggregates data based on the specified culture type.
    */
  public getData(type: string): void {
    this.filteredData = [];
    this.shrimpData = [];
    this.fishData = [];
    this.incrementDecrementCount = [];
    this.shrimpIncrementDecrement = [];
    this.fishIncrementDecrement = [];
    this.totalIncrementDecrement = [];
    let toDate = (moment(new Date()).format('YYYY-MM-DD')).toString();
    if (type == 'today') {
      let startDate = new Date(this.todayDate);
      let endDate = new Date(toDate);
      this.filteredData = this.marketConnects.filter(a => {
        let date = new Date(a.receivedDate.split('T')[0]);
        return (date >= startDate && date <= endDate);
      });
      let yDate = new Date(this.yesterDayDate);
      let yendDate = new Date(toDate);
      this.incrementDecrementCount = this.marketConnects.filter(a => {
        let date = new Date(a.receivedDate.split('T')[0]);
        return (date >= yDate && date < yendDate);
      });
    } else if (type == 'oneweek') {
      let startDate = new Date(this.weekfromDate);
      let endDate = new Date(toDate);
      this.filteredData = this.marketConnects.filter(a => {
        let date = new Date(a.receivedDate.split('T')[0]);
        return (date >= startDate && date <= endDate);
      });

      let lastWeekStartDate = new Date(this.lastWeekDate);
      let lastWeekEndDate = new Date(this.weekfromDate);
      this.incrementDecrementCount = this.marketConnects.filter(a => {
        let date = new Date(a.receivedDate.split('T')[0]);
        return (date >= lastWeekStartDate && date <= lastWeekEndDate);
      });
    } else if (type == 'onemonth') {
      let startDate = new Date(this.monthfromDate);
      let endDate = new Date(toDate);
      this.filteredData = this.marketConnects.filter(a => {
        let date = new Date(a.receivedDate.split('T')[0]);
        return (date >= startDate && date <= endDate);
      });
      let marchstartDate = new Date(this.lastMonthStartDate);
      let marchendDate = new Date(this.lastMonthEndDate);
      this.incrementDecrementCount = this.marketConnects.filter(a => {
        let marchdate = new Date(a.receivedDate.split('T')[0]);
        return (marchdate >= marchstartDate && marchdate <= marchendDate);
      });
    } else if (type == 'oneyear') {
      let startDate = new Date(this.yearfromDate);
      let endDate = new Date(toDate);
      this.filteredData = this.marketConnects.filter(a => {
        let date = new Date(a.receivedDate.split('T')[0]);
        return (date >= startDate && date <= endDate);
      });
      let yearstartDate = new Date(this.lastYearStartDate);
      let yearendDate = new Date(this.lastYearEndDate);
      this.incrementDecrementCount = this.marketConnects.filter(a => {
        let lastYeardate = new Date(a.receivedDate.split('T')[0]);
        return (lastYeardate >= yearstartDate && lastYeardate <= yearendDate);
      });
    }
    if (this.filteredData.length > 0 || this.incrementDecrementCount.length > 0) {
      this.makeData(this.culturetype);
    }
  }

  closeDateRangePopup() {
    this.isDateRangePopupOpen = false;
  }

  public onDateRangeApply(event: { fromDate: string; toDate: string }) {
    this.customFromDate = event.fromDate;
    this.customToDate = event.toDate;

    let startDate = new Date(this.customFromDate);
    let endDate = new Date(this.customToDate);

    // Ensure time is set correctly for accurate filtering
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    // Filter data within the custom date range
    this.filteredData = this.marketConnects.filter(a => {
      let date = new Date(a.receivedDate.split('T')[0]);
      date.setHours(0, 0, 0, 0);
      return date >= startDate && date <= endDate;
    });

    // Ensure increment/decrement data is correctly filtered for comparison
    let prevStartDate = new Date(this.lastMonthStartDate);
    let prevEndDate = new Date(this.lastMonthEndDate);
    prevStartDate.setHours(0, 0, 0, 0);
    prevEndDate.setHours(23, 59, 59, 999);

    this.incrementDecrementCount = this.marketConnects.filter(a => {
      let date = new Date(a.receivedDate.split('T')[0]);
      date.setHours(0, 0, 0, 0);
      return date >= prevStartDate && date <= prevEndDate;
    });

    // Close popup after selection
    this.isDateRangePopupOpen = false;

    // Call makeData function if needed
    if (this.filteredData.length > 0 || this.incrementDecrementCount.length > 0) {
      this.makeData(this.culturetype);
    }
  }


  /**
    * @method
    * @param {string} type - The selected date option ('today', 'oneweek', 'onemonth', 'oneyear', etc.).
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Retrieves and filters data based on the selected date option and organizes it for further processing.
    */
  public makeData(type: string): void {
    if (type == 'shrimp') {
      this.shrimpData = [];
      this.shrimpIncrementDecrement = [];
      this.culturetype = type;
    } else if (type == 'fish') {
      this.fishData = [];
      this.fishIncrementDecrement = [];
      this.culturetype = type;
    } else if (type == 'total') {
      this.totalData = [];
      this.totalIncrementDecrement = [];
      this.culturetype = type;
    }
    if (this.filteredData.length > 0) {
      for (let index = 0; index < this.filteredData.length; index++) {
        let eachObj = this.filteredData[index];
        let keys = Object.keys(eachObj);
        let tempObj: { [key: string]: any } = {};
        for (let j = 0; j < keys[j].length; j++) {
          let eachKey = keys[j];
          if (eachKey.indexOf(type) != -1) {
            tempObj[eachKey] = eachObj[eachKey];
          }
        }
        let tempObjKeys = Object.keys(tempObj); /// temp obj has keys like shrimp
        if (tempObjKeys.length > 0) {
          tempObj['receivedDate'] = eachObj['receivedDate'];
          tempObj['bbDemoRequested'] = eachObj['bbDemoRequested'];
          tempObj['bhDemoRequested'] = eachObj['bhDemoRequested'];
          tempObj['farmsRegistered_trial'] = eachObj['farmsRegistered_trial'];
          tempObj['farmsRegistered_converted'] = eachObj['farmsRegistered_converted'];
          tempObj['shrimpBuyerStockRequests'] = eachObj['shrimpBuyerStockRequests'];
          tempObj['fishBuyerStockRequests'] = eachObj['fishBuyerStockRequests'];
          tempObj['shrimpStockLeads'] = eachObj['shrimpStockLeads'];
          tempObj['fishStockLeads'] = eachObj['fishStockLeads'];
          tempObj['shrimpStockPosts'] = eachObj['shrimpStockPosts'];
          tempObj['fishStockPosts'] = eachObj['fishStockPosts'];
          this.hatcheryRegistred = 0;
          this.demoRequest = 0;
          this.seedPosted = 0;
          this.leadReceived = 0;
          this.bluHatchLeads = 0;
          this.bluHatchLeadsConverted = 0;
          this.blubayLeads = 0;
          this.blubayLeadsConverted = 0;
          this.farmsRegistred = 0;
          this.farmsDemoRequests = 0;
          this.farmsSeedRequest = 0;
          this.farmsQuoteRequest = 0;
          this.farmsStockLeads = 0;
          this.buyersRegistred = 0;
          this.buyersDemoRequests = 0;
          this.buyersStockRequest = 0;
          this.buyerLeadsRequest = 0;
          if (type == 'shrimp') {
            this.shrimpData.push(tempObj);
            for (let a = 0; a < this.shrimpData.length; a++) {
              this.hatcheryRegistred += Number(this.shrimpData[a].shrimpHatcheriesRegistered_trial); // hatcheryRegistred key
              this.demoRequest += Number(this.shrimpData[a].bhDemoRequested ? this.shrimpData[a].bhDemoRequested : 0); // demoRequest key
              this.seedPosted += Number(this.shrimpData[a].shrimpSeedPosted); // seedPosted key
              this.leadReceived += Number(this.shrimpData[a].shrimpQuoteRequested + this.shrimpData[a].shrimpSeedRequested); // leadReceived key
              this.bluHatchLeads += Number(this.shrimpData[a].shrimpHatcheriesRegistered_trial); // bluHatchLeads key
              this.bluHatchLeadsConverted += Number(this.shrimpData[a].shrimpHatcheriesRegistered_converted); // bluHatchLeadsConverted key
              this.blubayLeads += Number(this.shrimpData[a].farmsRegistered_trial ? this.shrimpData[a].farmsRegistered_trial : 0); // bluHatchLeadsConverted key
              this.blubayLeadsConverted += Number(this.shrimpData[a].farmsRegistered_converted ? this.shrimpData[a].farmsRegistered_converted : 0); // bluHatchLeadsConverted key
              this.farmsRegistred += Number(this.shrimpData[a].farmsRegistered_trial ? this.shrimpData[a].farmsRegistered_trial : 0); // bluHatchLeadsConverted key
              this.farmsDemoRequests += Number(this.shrimpData[a].bbDemoRequested ? this.shrimpData[a].bbDemoRequested : 0); // bluHatchLeadsConverted key
              this.farmsSeedRequest += Number(this.shrimpData[a].shrimpSeedRequested); // bluHatchLeadsConverted key
              this.farmsQuoteRequest += Number(this.shrimpData[a].shrimpQuoteRequested); // farmsQuoteRequest key
              this.farmsStockLeads += Number(this.shrimpData[a].shrimpStockPosts ? this.shrimpData[a].shrimpStockPosts : 0);
              this.buyersRegistred += Number(this.shrimpData[a].shrimpBuyersRegistered_trial);
              this.buyersDemoRequests = 0;
              this.buyersStockRequest += Number(this.shrimpData[a].shrimpBuyerStockRequests ? this.shrimpData[a].shrimpBuyerStockRequests : 0);
              this.buyerLeadsRequest += Number(this.shrimpData[a].shrimpStockLeads);
            }
            // this.fishData = [];
          } else if (type == 'fish') {
            this.fishData.push(tempObj);
            for (let a = 0; a < this.fishData.length; a++) {
              this.hatcheryRegistred += Number(this.fishData[a].fishHatcheriesRegistered_trial); // hatcheryRegistred key
              this.demoRequest = 0; // demoRequest key
              this.seedPosted += Number(this.fishData[a].fishSeedPosted); // seedPosted key
              this.leadReceived += Number(this.fishData[a].fishQuoteRequested + this.fishData[a].fishSeedRequested); // leadReceived key
              this.bluHatchLeads += Number(this.fishData[a].fishHatcheriesRegistered_trial); // bluHatchLeads key
              this.bluHatchLeadsConverted = 0; // bluHatchLeadsConverted key
              this.blubayLeads = 0; // bluHatchLeadsConverted key
              this.blubayLeadsConverted = 0; // bluHatchLeadsConverted key
              this.farmsRegistred = 0; // bluHatchLeadsConverted key
              this.farmsDemoRequests = 0; // bluHatchLeadsConverted key
              this.farmsSeedRequest += Number(this.fishData[a].fishSeedRequested); // bluHatchLeadsConverted key
              this.farmsQuoteRequest += Number(this.fishData[a].fishQuoteRequested); // farmsQuoteRequest key
              this.farmsStockLeads += Number(this.fishData[a].fishStockPosts ? this.fishData[a].fishStockPosts : 0);
              this.buyersRegistred += Number(this.fishData[a].fishBuyersRegistered_trial);
              this.buyersDemoRequests = 0;
              this.buyersStockRequest += Number(this.fishData[a].fishBuyerStockRequests ? this.fishData[a].fishBuyerStockRequests : 0);
              this.buyerLeadsRequest += Number(this.fishData[a].fishStockLeads);
            }
            // this.shrimpData = [];
          } else if (type == 'total') {
            this.totalData.push(tempObj);
            for (let a = 0; a < this.filteredData.length; a++) {
              // let ylead =
              this.hatcheryRegistred += this.filteredData[a].shrimpHatcheriesRegistered_trial + this.filteredData[a].fishHatcheriesRegistered_trial; // hatcheryRegistred key
              this.demoRequest += this.filteredData[a].bhDemoRequested; // demoRequest key
              this.seedPosted += Number(this.filteredData[a].totalSeedPosted); // seedPosted key
              this.leadReceived += Number(this.filteredData[a].totalSeedRequested); // leadReceived key
              this.bluHatchLeads += Number(this.filteredData[a].shrimpHatcheriesRegistered_trial + this.filteredData[a].fishHatcheriesRegistered_trial); // bluHatchLeads key
              this.bluHatchLeadsConverted += Number(this.filteredData[a].shrimpHatcheriesRegistered_converted); // bluHatchLeadsConverted key
              this.blubayLeads += this.filteredData[a].farmsRegistered_trial; // bluHatchLeadsConverted key
              this.blubayLeadsConverted += this.filteredData[a].farmsRegistered_converted; // bluHatchLeadsConverted key
              this.farmsRegistred += this.filteredData[a].farmsRegistered_trial; // bluHatchLeadsConverted key
              this.farmsDemoRequests += this.filteredData[a].bbDemoRequested; // bluHatchLeadsConverted key
              this.farmsSeedRequest += Number(this.filteredData[a].shrimpSeedRequested + this.filteredData[a].fishSeedRequested); // bluHatchLeadsConverted key
              this.farmsQuoteRequest += Number(this.filteredData[a].shrimpQuoteRequested + this.filteredData[a].fishQuoteRequested); // farmsQuoteRequest key
              this.farmsStockLeads += Number(this.filteredData[a].shrimpStockPosts + this.filteredData[a].fishStockPosts);
              this.buyersRegistred += Number(this.filteredData[a].shrimpBuyersRegistered_trial + this.filteredData[a].fishBuyersRegistered_trial);
              this.buyersDemoRequests = 0;
              this.buyersStockRequest += Number(this.filteredData[a].shrimpBuyerStockRequests + this.filteredData[a].fishBuyerStockRequests);
              this.buyerLeadsRequest += Number(this.filteredData[a].shrimpStockLeads + this.filteredData[a].fishStockLeads);
            }
          }
        }
      }
    }
    if (this.incrementDecrementCount.length > 0) {
      for (let index = 0; index < this.incrementDecrementCount.length; index++) {
        let eachObj = this.incrementDecrementCount[index] as Record<string, any>;
        let keys = Object.keys(eachObj);
        let tempObj: Record<string, any> = {};
        for (let j = 0; j < keys.length; j++) {
          let eachKey = keys[j];
          if (eachKey.indexOf(type) !== -1) {
            tempObj[eachKey] = eachObj[eachKey];
          }
        }
        let tempObjKeys = Object.keys(tempObj); /// temp obj has keys like shrimp
        if (tempObjKeys.length > 0) {
          tempObj['receivedDate'] = eachObj['receivedDate'];
          tempObj['bbDemoRequested'] = eachObj['bbDemoRequested'];
          tempObj['bhDemoRequested'] = eachObj['bhDemoRequested'];
          tempObj['farmsRegistered_trial'] = eachObj['farmsRegistered_trial'];
          tempObj['farmsRegistered_converted'] = eachObj['farmsRegistered_converted'];
          this.hatcheryLeadRegistredCount = 0;
          this.hatcheryLeadsConvertedCount = 0;
          this.blubayLeadsRegistredCount = 0;
          this.blubayLeadsConvertedCount = 0;

          this.incrementHatcheryRegister = 0;
          this.incrementHatcheryDemoReq = 0;
          this.incrementHatcherySeed = 0;
          this.incrementHatcheryLeed = 0;
          this.incrementFarmRegister = 0;
          this.incrementFarmDemoReq = 0;
          this.incrementFarmSeed = 0;
          this.incrementFarmLeed = 0;
          this.incrementBuyerRegister = 0;
          this.incrementBuyerDemoReq = 0;
          this.incrementBuyerStock = 0;
          this.incrementBuyerLeed = 0;
          if (type == 'shrimp') {
            this.shrimpIncrementDecrement.push(tempObj);
            for (let a = 0; a < this.shrimpIncrementDecrement.length; a++) {
              this.incrementHatcheryRegister += this.shrimpIncrementDecrement[a].shrimpHatcheriesRegistered_trial; // hatcheryRegistred key
              this.incrementHatcheryDemoReq += this.shrimpIncrementDecrement[a].bhDemoRequested; // demoRequest key
              this.incrementHatcherySeed += Number(this.shrimpIncrementDecrement[a].shrimpSeedPosted); // seedPosted key
              this.incrementHatcheryLeed += Number(this.shrimpIncrementDecrement[a].shrimpSeedRequested + this.shrimpIncrementDecrement[a].shrimpQuoteRequested); // leadReceived key

              this.incrementFarmRegister += this.shrimpIncrementDecrement[a].farmsRegistered_trial; // bluHatchLeadsConverted key
              this.incrementFarmDemoReq += this.shrimpIncrementDecrement[a].bbDemoRequested; // bluHatchLeadsConverted key
              this.incrementFarmSeed += Number(this.shrimpIncrementDecrement[a].shrimpSeedRequested); // bluHatchLeadsConverted key
              this.incrementFarmLeed += Number(this.shrimpIncrementDecrement[a].shrimpQuoteRequested); // farmsQuoteRequest key
              this.incrementFarmsStockLeads += Number(this.shrimpIncrementDecrement[a].shrimpStockPosts ? this.shrimpIncrementDecrement[a].shrimpStockPosts : 0);

              this.hatcheryLeadRegistredCount += Number(this.shrimpIncrementDecrement[a].shrimpHatcheriesRegistered_trial) - this.bluHatchLeads; // bluHatchLeads key
              this.hatcheryLeadsConvertedCount += Number(this.shrimpIncrementDecrement[a].shrimpHatcheriesRegistered_converted) - this.bluHatchLeadsConverted; // bluHatchLeadsConverted key
              this.blubayLeadsRegistredCount += Number(this.shrimpIncrementDecrement[a].farmsRegistered_trial ? this.shrimpIncrementDecrement[a].farmsRegistered_trial : 0) - this.blubayLeads; // bluHatchLeadsConverted key
              this.blubayLeadsConvertedCount += Number(this.shrimpIncrementDecrement[a].farmsRegistered_converted ? this.shrimpIncrementDecrement[a].farmsRegistered_converted : 0) - this.blubayLeadsConverted; // bluHatchLeadsConverted key

              this.incrementBuyerRegister += Number(this.shrimpIncrementDecrement[a].shrimpBuyersRegistered_trial ? this.shrimpIncrementDecrement[a].shrimpBuyersRegistered_trial : 0);
              this.incrementBuyerDemoReq = 0;
              this.incrementBuyerStock += Number(this.shrimpIncrementDecrement[a].shrimpBuyerStockRequests ? this.shrimpIncrementDecrement[a].shrimpBuyerStockRequests : 0);
              this.incrementBuyerLeed += Number(this.shrimpIncrementDecrement[a].shrimpStockLeads ? this.shrimpIncrementDecrement[a].shrimpStockLeads : 0);
            }
          } else if (type == 'fish') {
            this.fishIncrementDecrement.push(tempObj);
            for (let a = 0; a < this.fishIncrementDecrement.length; a++) {
              this.incrementHatcheryRegister += this.fishIncrementDecrement[a].fishHatcheriesRegistered_trial; // hatcheryRegistred key
              this.incrementHatcheryDemoReq = 0; // demoRequest key
              this.incrementHatcherySeed += Number(this.fishIncrementDecrement[a].fishSeedPosted); // seedPosted key
              this.incrementHatcheryLeed += Number(this.fishIncrementDecrement[a].fishSeedRequested + this.fishIncrementDecrement[a].fishQuoteRequested); // leadReceived key

              this.incrementFarmRegister = 0;
              this.incrementFarmDemoReq = 0;
              this.incrementFarmSeed += Number(this.fishIncrementDecrement[a].fishSeedRequested); // bluHatchLeadsConverted key
              this.incrementFarmLeed += Number(this.fishIncrementDecrement[a].fishQuoteRequested); // farmsQuoteRequest key
              this.incrementFarmsStockLeads += Number(this.shrimpIncrementDecrement[a].fishStockPosts ? this.shrimpIncrementDecrement[a].fishStockPosts : 0);

              this.hatcheryLeadRegistredCount += Number(this.fishIncrementDecrement[a].fishHatcheriesRegistered_trial); // bluHatchLeads key
              this.hatcheryLeadsConvertedCount = 0; // bluHatchLeadsConverted key
              this.blubayLeadsRegistredCount = 0; // bluHatchLeadsConverted key
              this.blubayLeadsConvertedCount = 0; // bluHatchLeadsConverted key

              this.incrementBuyerRegister = 0;
              this.incrementBuyerDemoReq = 0;
              this.incrementBuyerStock += Number(this.fishIncrementDecrement[a].fishBuyerStockRequests);
              this.incrementBuyerLeed += Number(this.fishIncrementDecrement[a].fishStockLeads);
            }
          } else if (type == 'total') {
            this.totalIncrementDecrement.push(tempObj);
            if (this.incrementDecrementCount.length > 0) {
              for (let a = 0; a < this.incrementDecrementCount.length; a++) {
                this.incrementHatcheryRegister += this.incrementDecrementCount[a].shrimpHatcheriesRegistered_trial + this.incrementDecrementCount[a].fishHatcheriesRegistered_trial; // hatcheryRegistred key
                this.incrementHatcheryDemoReq += this.incrementDecrementCount[a].bhDemoRequested; // demoRequest key
                this.incrementHatcherySeed += Number(this.incrementDecrementCount[a].totalSeedPosted); // seedPosted key
                this.incrementHatcheryLeed += Number(this.incrementDecrementCount[a].totalSeedRequested); // leadReceived key

                this.incrementFarmRegister += this.incrementDecrementCount[a].farmsRegistered_trial; // bluHatchLeadsConverted key
                this.incrementFarmDemoReq += this.incrementDecrementCount[a].bbDemoRequested; // bluHatchLeadsConverted key
                this.incrementFarmSeed += Number(this.incrementDecrementCount[a].shrimpSeedRequested + this.incrementDecrementCount[a].fishSeedRequested); // bluHatchLeadsConverted key
                this.incrementFarmLeed += Number(this.incrementDecrementCount[a].shrimpQuoteRequested + this.incrementDecrementCount[a].fishQuoteRequested); // farmsQuoteRequest key
                this.incrementFarmsStockLeads += Number(this.incrementDecrementCount[a].fishStockPosts + this.incrementDecrementCount[a].shrimpStockPosts);

                this.hatcheryLeadRegistredCount += (Number((this.incrementDecrementCount[a].shrimpHatcheriesRegistered_trial ? this.incrementDecrementCount[a].shrimpHatcheriesRegistered_trial : 0) + this.incrementDecrementCount[a].fishHatcheriesRegistered_trial ? this.incrementDecrementCount[a].fishHatcheriesRegistered_trial : 0)); // bluHatchLeads key
                this.hatcheryLeadsConvertedCount += (Number(this.incrementDecrementCount[a].shrimpHatcheriesRegistered_converted ? this.incrementDecrementCount[a].shrimpHatcheriesRegistered_converted : 0)); // bluHatchLeadsConverted key
                this.blubayLeadsRegistredCount += (Number(this.incrementDecrementCount[a].farmsRegistered_trial ? this.incrementDecrementCount[a].farmsRegistered_trial : 0)); // bluHatchLeadsConverted key
                this.blubayLeadsConvertedCount += (Number(this.incrementDecrementCount[a].farmsRegistered_converted ? this.incrementDecrementCount[a].farmsRegistered_converted : 0)); // bluHatchLeadsConverted key

                this.incrementBuyerRegister += this.incrementDecrementCount[a].shrimpBuyersRegistered_trial + this.incrementDecrementCount[a].fishBuyersRegistered_trial;
                this.incrementBuyerDemoReq = 0;
                this.incrementBuyerStock += Number(this.incrementDecrementCount[a].shrimpBuyerStockRequests + this.incrementDecrementCount[a].fishBuyerStockRequests);
                this.incrementBuyerLeed += Number(this.incrementDecrementCount[a].shrimpStockLeads + this.incrementDecrementCount[a].fishStockLeads);
              }
            }
          }
        }
      }
    }
  }

  /**
    * @method
    * @param {string} val - The selected time range ('today', 'oneweek', 'onemonth', 'oneyear').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Updates the hatchery table data based on the selected time range.
    */
  previousHatcheryTableDays: any;
  public tableDays(val: string): void {
    this.tablenoOfDays = val;
    this.finalData = [];
    this.dispFinalData = [];
    this.isFiltering = false;
    this.clearHatcherySearchInput = false;
    this.hatcherySearch = '';
    // Store previous selection before changing
    if (val !== 'Custom') {
      this.previousHatcheryTableDays = val;
    }
    this.tablenoOfDays = val;
    // Reset custom date values when selecting predefined ranges
    if (val !== 'Custom') {
      this.customHatcheryFromDate = '';
      this.customHatcheryToDate = '';
    }
    // If 'Custom' is selected, open the date range popup
    if (val === 'Custom') {
      this.isHatcheryDateRangePopupOpen = true;
    } else {
      this.tablegetData(val);
    }
  }

  /**
    * @method
    * @param {string} type - The type of time range ('today', 'oneweek', 'onemonth', 'oneyear').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Retrieves and filters data for the hatchery table based on the selected time range.
    */
  public tablegetData(type: string): void {
    this.tablefilteredData = [];
    let toDate = (moment(new Date()).format('YYYY-MM-DD')).toString();
    if (type == 'today') {
      this.finalData = [];
      let startDate = new Date(this.todayDate);
      let endDate = new Date(toDate);
      this.tablefilteredData = this.customerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    } else if (type == 'oneweek') {
      this.finalData = [];
      let startDate = new Date(this.weekfromDate);
      let endDate = new Date(toDate);
      this.tablefilteredData = this.customerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    } else if (type == 'onemonth') {
      this.finalData = [];
      let startDate = new Date(this.monthfromDate);
      let endDate = new Date(toDate);
      this.tablefilteredData = this.customerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    } else if (type == 'oneyear') {
      this.finalData = [];
      let startDate = new Date(this.yearfromDate);
      let endDate = new Date(toDate);
      this.tablefilteredData = this.customerLeads.filter(a => {
        let date = new Date(a.generatedDate.split('T')[0]);
        return (date >= startDate && date <= endDate);
      });
    }
    if (this.tablefilteredData.length > 0) {
      this.tablemakeData(this.tableculturetype, this.tableSelectionKey);
    }
  }

  public closeHatcheryDateRangePopup() {
    this.isHatcheryDateRangePopupOpen = false;

    // Revert to last selection if custom range is incomplete
    if (!this.customHatcheryFromDate || !this.customHatcheryToDate) {
      this.tablenoOfDays = this.previousHatcheryTableDays;
      this.tablegetData(this.tablenoOfDays);
    } else {
      this.onHatcheryDateRangeApply({
        fromDate: this.customHatcheryFromDate,
        toDate: this.customHatcheryToDate
      });
    }
  }

  public onHatcheryDateRangeApply(event: { fromDate: string; toDate: string }) {
    this.customHatcheryFromDate = event.fromDate;
    this.customHatcheryToDate = event.toDate;
    this.finalData = [];
    this.dispFinalData = [];

    let startDate = new Date(this.customHatcheryFromDate);
    let endDate = new Date(this.customHatcheryToDate);

    // Ensure time is set correctly for accurate filtering
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    // Filter data within the custom date range safely
    this.tablefilteredData = this.customerLeads.filter(a => {
      if (!a.generatedDate) return false;  //Handle null or undefined dates safely

      let dateStr = a.generatedDate.split('T')[0];  // Extract only the date part
      let date = new Date(dateStr);
      date.setHours(0, 0, 0, 0);
      return date >= startDate && date <= endDate;
    });

    //  Close popup after selection
    this.isHatcheryDateRangePopupOpen = false;

    if (this.tablefilteredData.length > 0) {
      this.tablemakeData(this.tableculturetype, this.tableSelectionKey);
    }
  }



  /**
    * @method
    * @param {string} type - The type of filter ('shrimp', 'fish', or 'total').
    * @param {string} value - The value to filter by ('Hatchery').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Generates and filters hatchery related data based on the provided type and value.
   */
  public async tablemakeData(type: string, value: string) {
    this.finalData = [];
    this.dispFinalData = [];
    if (type == 'shrimp' && value == 'Hatchery') {
      if (this.tablefilteredData.length > 0) {
        for (let u = 0; u < this.tablefilteredData.length; u++) {
          let each = this.tablefilteredData[u];
          if (['Register as hatchery', 'Request Demo', 'Post your requirement', 'Request quote'].includes(each.event)) {
            if (each.event == 'Request Demo' && each.lead_from == 'Hatchery') {
              this.finalData.push(each);
              this.dispFinalData = this.finalData;
            } else if (each.lead_culture.name == 'Shrimp' && each.event != 'Request Demo') {
              this.finalData.push(each);
            }
          }
        }
      }
    } else if (type == 'fish' && value == 'Hatchery') {
      if (this.tablefilteredData.length > 0) {
        for (let u = 0; u < this.tablefilteredData.length; u++) {
          let each = this.tablefilteredData[u];
          if (each.lead_culture.name == 'Fish culture' && each.event != 'Post Fish Stock Request' && each.event != 'Interested in Fish stock' && each.event != 'Fish stock post') {
            this.finalData.push(each);
          }
        }
      }
    } else if (type == 'total' && value == 'Hatchery') {
      if (this.tablefilteredData.length > 0) {
        for (let u = 0; u < this.tablefilteredData.length; u++) {
          let each = this.tablefilteredData[u];
          if ((each.lead_from == 'Hatchery') || (each.lead_from == 'Farmer' && (each.event == 'Request quote' || each.event == 'Post your requirement'))) {
            this.finalData.push(each);
          }
        }
      }
    }
    this.initializeBatchLoader(); // Reset instance
    this.batchLoader.reset();     // Clear state
    await this.batchLoader.loadNextBatch(true); // Load first batch
  }

  /**
    * @method
    * @param {string} type - The type of section tab to be selected.
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Changes the section tab for the hatchery table and updates data accordingly.
    */
  public tableSectionTab(type: string): void {
    this.tableSelectionKey = type;
    this.tablemakeData(this.tableculturetype, type);
  }

  /**
    * @method
    * @param {string} type - The type of culture to be selected ('total', 'shrimp', 'fish').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Changes the culture selection for the hatchery table and updates data accordingly.
    */
  public tableCultureSeletion(type: string): void {
    this.cultureCategoryId = undefined;
    this.tableculturetype = type;
    this.clearHatcherySearchInput = false;
    this.hatcherySearch = '';
    this.finalData = [];
    this.dispFinalData = [];
    this.isFiltering = false;
    if (type == 'total') {
      this.cultureCategoryId = 'All';
    } else if (type == 'shrimp') {
      this.cultureCategoryId = 1;
    } else {
      this.cultureCategoryId = 2;
    }
    this.tablemakeData(type, this.tableSelectionKey);
  }

  /**
    * @method
    * @param {string} val - The selected time range ('today', 'oneweek', 'onemonth', 'oneyear').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Updates the market connect table data based on the selected time range.
    */
  previousMCTableDays: any;
  public marketconnecttableDays(val: string): void {
    this.marketconnectfinalData = [];
    this.dispmarketconnectfinalData = [];
    this.isFiltering = false;
    this.marketconnecttablenoOfDays = val;
    this.clearMCSearchInput = false;
    this.marketConnectSearch = '';
    // Store previous selection before changing
    if (val !== 'Custom') {
      this.previousMCTableDays = val;
    }
    this.marketconnecttablenoOfDays = val;
    // Reset custom date values when selecting predefined ranges
    if (val !== 'Custom') {
      this.customMCREPFromDate = '';
      this.customMCREPToDate = '';
    }
    // If 'Custom' is selected, open the date range popup
    if (val === 'Custom') {
      this.isMCREPDateRangePopupOpen = true;
    } else {
      this.marketconnecttablegetData(val);
    }
  }

  /**
    * @method
    * @param {string} type - The type of culture to be selected ('total', 'shrimp', 'fish').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Changes the culture selection for the market connect table and updates data accordingly.
    */
  public marketConnectTableCultureSelection(type: string): void {
    this.marketconnectfinalData = [];
    this.dispmarketconnectfinalData = [];
    this.isFiltering = false;
    this.marketActivePageNo = 1;
    this.cultureCategoryId = undefined;
    this.marketconnecttableculturetype = type;
    this.clearMCSearchInput = false;
    this.marketConnectSearch = '';
    if (type == 'total') {
      this.cultureCategoryId = 'All';
    } else if (type == 'shrimp') {
      this.cultureCategoryId = 1;
    } else {
      this.cultureCategoryId = 2;
    }
    this.marketConnectTableMakeData(type, this.marketconnecttableSelectionKey);
  }

  /**
    * @method
    * @param {string} type - The type of section tab to be selected.
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Changes the section tab for the market connect table and updates data accordingly.
    */
  public marketconnecttableSectionTab(type: string): void {
    this.marketconnectfinalData = [];
    this.dispmarketconnectfinalData = [];
    this.isFiltering = false;
    this.marketconnecttableSelectionKey = type;
    this.marketConnectTableMakeData(this.marketconnecttableculturetype, type);
    if (type == 'Hatchery') {
      this.hatcheryName = true;
      this.farmName = false;
      this.buyerLocationName = false;
    } else if (type == 'Farm') {
      this.farmName = true;
      this.hatcheryName = false;
      this.buyerLocationName = false;
    } else if (type == 'Buyer') {
      this.farmName = false;
      this.hatcheryName = false;
      this.buyerLocationName = true;
      this.marketconnecttableSelectionKey = 'Buyer';
    }
  }

  /**
    * @method
    * @param {string} type - The type of time range ('today', 'oneweek', 'onemonth', 'oneyear').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Retrieves and filters data for the market connect table based on the selected time range.
    */
  public marketconnecttablegetData(type: string): void {
    this.marketconnecttablefilteredData = [];
    let toDate = (moment(new Date()).format('YYYY-MM-DD')).toString();
    if (type == 'today') {
      this.marketconnectfinalData = [];
      let startDate = new Date(this.todayDate);
      let endDate = new Date(toDate);
      this.marketconnecttablefilteredData = this.marketConnectCustomerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    } else if (type == 'oneweek') {
      this.marketconnectfinalData = [];
      let startDate = new Date(this.weekfromDate);
      let endDate = new Date(toDate);
      this.marketconnecttablefilteredData = this.marketConnectCustomerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    } else if (type == 'onemonth') {
      this.marketconnectfinalData = [];
      let startDate = new Date(this.monthfromDate);
      let endDate = new Date(toDate);
      this.marketconnecttablefilteredData = this.marketConnectCustomerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    } else if (type == 'oneyear') {
      this.marketconnectfinalData = [];
      let startDate = new Date(this.yearfromDate);
      let endDate = new Date(toDate);
      this.marketconnecttablefilteredData = this.marketConnectCustomerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    }
    if (this.marketconnecttablefilteredData.length > 0) {
      this.marketConnectTableMakeData(this.marketconnecttableculturetype, this.marketconnecttableSelectionKey);
    }
  }

  public closeMCREPDateRangePopup() {
    this.isMCREPDateRangePopupOpen = false;
    // Revert back to last selected option if no custom dates are applied
    if (!this.customMCREPFromDate || !this.customMCREPToDate) {
      this.marketconnecttablenoOfDays = this.previousMCTableDays;
      this.marketconnecttablegetData(this.marketconnecttablenoOfDays)
    } else {
      this.onMCREPDateRangeApply({
        fromDate: this.customMCREPFromDate,
        toDate: this.customMCREPToDate
      });
    }
  }

  public onMCREPDateRangeApply(event: { fromDate: string; toDate: string }) {
    this.customMCREPFromDate = event.fromDate;
    this.customMCREPToDate = event.toDate;
    this.marketconnectfinalData = [];
    this.dispmarketconnectfinalData = [];

    let startDate = new Date(this.customMCREPFromDate);
    let endDate = new Date(this.customMCREPToDate);

    // Ensure time is set correctly for accurate filtering
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    // Filter data within the custom date range safely
    this.marketconnecttablefilteredData = this.marketConnectCustomerLeads.filter(a => {
      if (!a.generatedDate) return false;  //Handle null or undefined dates safely

      let dateStr = a.generatedDate.split('T')[0];  // Extract only the date part
      let date = new Date(dateStr);
      date.setHours(0, 0, 0, 0);
      return date >= startDate && date <= endDate;
    });

    //  Close popup after selection
    this.isMCREPDateRangePopupOpen = false;

    if (this.marketconnecttablefilteredData.length > 0) {
      this.marketConnectTableMakeData(this.marketconnecttableculturetype, this.marketconnecttableSelectionKey);
    }
  }

  /**
    * @method
    * @param {string} type - The type of filter ('shrimp', 'fish', or 'total').
    * @param {string} value - The value to filter by ('Farm' or 'Hatchery').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Generates and filters market connect related data based on the provided type and value.
   */
  public async marketConnectTableMakeData(type: string, value: string) {
    this.marketconnectfinalData = [];
    this.dispmarketconnectfinalData = [];
    if (type == 'shrimp' && value == 'Hatchery') {
      if (this.marketconnecttablefilteredData.length > 0) {
        for (let u = 0; u < this.marketconnecttablefilteredData.length; u++) {
          let each = this.marketconnecttablefilteredData[u];
          if (each.lead_culture.name == 'Shrimp' && each.event == 'Register as hatchery') {
            this.marketconnectfinalData.push(each);
          }
        }
      }
    } else if (type == 'shrimp' && value == 'Farm') {
      if (this.marketconnecttablefilteredData.length > 0) {
        for (let u = 0; u < this.marketconnecttablefilteredData.length; u++) {
          let each = this.marketconnecttablefilteredData[u];
          if (each.lead_culture.name == 'Shrimp' && each.event == 'Register as farmer' || each.event == 'Shrimp stock post') {
            this.marketconnectfinalData.push(each);
          }
        }
      }
    } else if (type == 'fish' && value == 'Hatchery') {
      if (this.marketconnecttablefilteredData.length > 0) {
        for (let u = 0; u < this.marketconnecttablefilteredData.length; u++) {
          let each = this.marketconnecttablefilteredData[u];
          if (each.lead_culture.name == 'Fish culture' && each.event == 'Register as hatchery') {
            this.marketconnectfinalData.push(each);
          }
        }
      }
    } else if (type == 'fish' && value == 'Farm') {
      if (this.marketconnecttablefilteredData.length > 0) {
        for (let u = 0; u < this.marketconnecttablefilteredData.length; u++) {
          let each = this.marketconnecttablefilteredData[u];
          if (each.lead_culture.name == 'Fish culture' && each.event == 'Register as farmer' || each.event == 'Fish stock post') {
            this.marketconnectfinalData.push(each);
          }
        }
      }
    } else if (type == 'shrimp' && value == 'Buyer') {
      this.displayHatcherySite = false;
      if (this.marketconnecttablefilteredData.length > 0) {
        for (let u = 0; u < this.marketconnecttablefilteredData.length; u++) {
          let each = this.marketconnecttablefilteredData[u];
          if (each.lead_culture.name == 'Shrimp' && (each.event == 'Post Shrimp Stock Request' || each.event == 'Interested in Shrimp stock')) {
            this.marketconnectfinalData.push(each);
          }
        }
      }
    } else if (type == 'fish' && value == 'Buyer') {
      this.displayHatcherySite = false;
      if (this.marketconnecttablefilteredData.length > 0) {
        for (let u = 0; u < this.marketconnecttablefilteredData.length; u++) {
          let each = this.marketconnecttablefilteredData[u];
          if (each.lead_culture.name == 'Fish culture' && (each.event == 'Post Fish Stock Request' || each.event == 'Interested in Fish stock')) {
            this.marketconnectfinalData.push(each);
          }
        }
      }
    }
    else if (type == 'total' && value == 'Hatchery') {
      if (this.marketconnecttablefilteredData.length > 0) {
        for (let u = 0; u < this.marketconnecttablefilteredData.length; u++) {
          let each = this.marketconnecttablefilteredData[u];
          if (each.event == 'Register as hatchery') {
            this.marketconnectfinalData.push(each);
          }
        }
      }
    } else if (type == 'total' && value == 'Farm') {
      if (this.marketconnecttablefilteredData.length > 0) {
        for (let u = 0; u < this.marketconnecttablefilteredData.length; u++) {
          let each = this.marketconnecttablefilteredData[u];
          if (each.event == 'Register as farmer' || each.event == 'Shrimp stock post' || each.event == 'Fish stock post' || each.event == 'Post your requirement' || each.event == 'Request quote') {
            this.marketconnectfinalData.push(each);
          }
        }
      }
    } else if (type == 'total' && value == 'Buyer') {
      this.displayHatcherySite = false;
      if (this.marketconnecttablefilteredData.length > 0) {
        for (let u = 0; u < this.marketconnecttablefilteredData.length; u++) {
          let each = this.marketconnecttablefilteredData[u];
          if (each.event == 'Register as Retailer' || each.event == 'Register as Exporter' || each.event == 'Register as Middle Man' || each.event == 'Register as Food Chain Owner' || each.event == 'Post Shrimp Stock Request' || each.event == 'Post Fish Stock Request' || each.event == 'Interested in Shrimp stock' || each.event == 'Interested in Fish stock') {
            this.marketconnectfinalData.push(each);
          }
        }
      }
    }
    this.initializeBatchLoader(); // Reset instance
    this.batchLoader.reset();     // Clear state
    await this.batchLoader.loadNextBatch(true); // Load first batch
  }

  /**
    * @method
    * @param {string} val - The selected time range ('today', 'oneweek', 'onemonth', 'oneyear').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Updates the market connect graph data based on the selected time range.
    */
  previousMCGraphTableDays: any;
  public marketconnecttableGraphDays(val: string): void {
    this.marketconnecttableGraphnoOfDays = val;
    // Store previous selection before changing
    if (val !== 'Custom') {
      this.previousMCGraphTableDays = val;
    }
    this.marketconnecttableGraphnoOfDays = val;
    // Reset custom date values when selecting predefined ranges
    if (val !== 'Custom') {
      this.customMCFromDate = '';
      this.customMCToDate = '';
    }
    // If 'Custom' is selected, open the date range popup
    if (val === 'Custom') {
      this.isMCDateRangePopupOpen = true;
    } else {
      this.marketconnecttableGraphGetData(val);
    }
  }

  /**
    * @method
    * @param {string} type - The type of culture to be selected ('total', 'shrimp', 'fish').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Changes the culture selection for the market connect graph and updates data accordingly.
    */
  public marketConnectTableGraphCultureSelection(type: string): void {
    this.marketconnecttableGraphculturetype = type;
    this.marketConnectTableGraphMakeData(type, this.marketconnecttableGraphSelectionKey);
  }

  /**
    * @method
    * @param {string} type - The type of section tab to be selected.
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Changes the section tab for the market connect graph and updates data accordingly.
    */
  public marketconnecttableGraphSectionTab(type: string): void {
    this.marketconnecttableGraphSelectionKey = type;
    this.marketConnectTableGraphMakeData(this.marketconnecttableGraphculturetype, type);
    if (type == 'Hatchery') {
      this.hatcheryName = true;
      this.farmName = false;
    } else if (type == 'Farm') {
      this.farmName = true;
      this.hatcheryName = false;
    }
  }

  /**
    * @method
    * @param {string} type - The type of time range ('today', 'oneweek', 'onemonth', 'oneyear').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Retrieves and filters data for the market connect graph based on the selected time range.
    */
  public marketconnecttableGraphGetData(type: string): void{
    this.dateRange = [];
    let toDate = (moment(new Date()).format('YYYY-MM-DD')).toString();
    if (type == 'today') {
      let startDate = new Date(this.todayDate);
      let endDate = new Date(toDate);
      this.dateRange.push(toDate);
      this.marketConnectgraphfilteredData = this.marketConnectGraph.filter(a => {
        let date = new Date(a.receivedDate.split('T')[0]);
        return (date >= startDate && date <= endDate);
      });
    } else if (type == 'oneweek') {
      let startDate = new Date(this.weekfromDate);
      let endDate = new Date(toDate);
      const getDaysArray = (s: Date | string, e: Date | string, stepDays: number): string[] => {
        const dates: string[] = [];
        for (let d = new Date(s); d <= new Date(e); d.setDate(d.getDate() + stepDays)) {
          dates.push(new Date(d).toISOString().slice(0, 10));
        }
        return dates;
      };
      this.dateRange = getDaysArray(startDate, endDate, 1);
      this.marketConnectgraphfilteredData = this.marketConnectGraph.filter(a => {
        let date = new Date(a.receivedDate.split('T')[0]);
        return (date >= startDate && date <= endDate);
      });
    } else if (type == 'onemonth') {
      let startDate = new Date(this.monthfromDate);
      let endDate = new Date(toDate);
      const getDaysArray = (s: Date | string, e: Date | string, stepDays: number): string[] => {
        const dates: string[] = [];
        for (let d = new Date(s); d <= new Date(e); d.setDate(d.getDate() + stepDays)) {
          dates.push(new Date(d).toISOString().slice(0, 10));
        }
        return dates;
      };
      this.dateRange = getDaysArray(startDate, endDate, 6);
      this.marketConnectgraphfilteredData = this.marketConnectGraph.filter(a => {
        let date = new Date(a.receivedDate.split('T')[0]);
        return (date >= startDate && date <= endDate);
      });
    } else if (type == 'oneyear') {
      let startDate = new Date(this.yearfromDate);
      let endDate = new Date(toDate);
      const getDaysArray = (s: Date | string, e: Date | string, stepDays: number): string[] => {
        const dates: string[] = [];
        for (let d = new Date(s); d <= new Date(e); d.setDate(d.getDate() + stepDays)) {
          dates.push(new Date(d).toISOString().slice(0, 10));
        }
        return dates;
      };
      this.dateRange = getDaysArray(startDate, endDate, 60);
      this.marketConnectgraphfilteredData = this.marketConnectGraph.filter(a => {
        let date = new Date(a.receivedDate.split('T')[0]);
        return (date >= startDate && date <= endDate);
      });
    }
    this.marketConnectTableGraphMakeData(this.marketconnecttableGraphculturetype,this.marketconnecttableGraphSelectionKey)
  }

  closeMCDateRangePopup() {
    this.isMCDateRangePopupOpen = false;
    // Revert back to last selected option if no custom dates are applied
    if (!this.customMCFromDate || !this.customMCToDate) {
      this.marketconnecttableGraphnoOfDays = this.previousMCGraphTableDays;
    }
  }

  public onMCDateRangeApply(event: { fromDate: string; toDate: string }) {
    this.customMCFromDate = event.fromDate;
    this.customMCToDate = event.toDate;

    let startDate = new Date(this.customMCFromDate);
    let endDate = new Date(this.customMCToDate);

    // Ensure time is set correctly for accurate filtering
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    // Filter data within the custom date range safely
    this.marketConnectgraphfilteredData = this.marketConnectGraph.filter(a => {
      if (!a.receivedDate) return false;  // Handle null or undefined dates safely

      let dateStr = a.receivedDate.split('T')[0];  // Extract only the date part
      let date = new Date(dateStr);
      date.setHours(0, 0, 0, 0);
      return date >= startDate && date <= endDate;
    });

    //  Close popup after selection
    this.isMCDateRangePopupOpen = false;

    this.marketConnectTableGraphMakeData(this.marketconnecttableGraphculturetype,this.marketconnecttableGraphSelectionKey)
  }

  /**
    * @method
    * @param {string} type - The type of filter ('shrimp', 'fish', or 'total').
    * @param {string} value - The value to filter by ('Farm' or 'Hatchery').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Generates and filters market connect graph related data based on the provided type and value.
   */
  public marketConnectTableGraphMakeData(type: string, value: string): void {
    this.dataPoints = [];
    this.dataPoints2 = [];
    let converted = 0;
    if (type == 'shrimp' && value == 'Hatchery') {
      if (this.marketConnectgraphfilteredData.length > 0) {
        for (let i = 0; i < this.marketConnectgraphfilteredData.length; i++) {
          this.dataPoints.push({
            x: new Date(this.marketConnectgraphfilteredData[i].updatedAt),
            y: Number(this.marketConnectgraphfilteredData[i].bhDemoRequested + this.marketConnectgraphfilteredData[i].shrimpHatcheriesRegistered_trial)
          });
          this.dataPoints2.push({
            x: new Date(this.marketConnectgraphfilteredData[i].updatedAt),
            y: Number(this.marketConnectgraphfilteredData[i].shrimpHatcheriesRegistered_converted)
          });
        }
      }else{
        for(let j = 0; j < this.dateRange.length; j++){
          this.dataPoints.push({x:new Date(this.dateRange[j]),y:0})
          this.dataPoints2.push({x:new Date(this.dateRange[j]),y:0})
        }
      }
      this.marketConnectChart(this.dataPoints, this.dataPoints2);
    } else if (type == 'shrimp' && value == 'Farm') {
      if (this.marketConnectgraphfilteredData.length > 0) {
        for (let i = 0; i < this.marketConnectgraphfilteredData.length; i++) {
          this.dataPoints.push({
            x: new Date(this.marketConnectgraphfilteredData[i].updatedAt),
            y: Number(this.marketConnectgraphfilteredData[i].bbDemoRequested + this.marketConnectgraphfilteredData[i].farmsRegistered_trial + this.marketConnectgraphfilteredData[i].shrimpQuoteRequested + this.marketConnectgraphfilteredData[i].shrimpSeedRequested)
          });
          this.dataPoints2.push({
            x: new Date(this.marketConnectgraphfilteredData[i].updatedAt),
            y: Number(this.marketConnectgraphfilteredData[i].farmsRegistered_converted)
          });
        }
      }else{
        for(let j = 0;j < this.dateRange.length; j++){
          this.dataPoints.push({x:new Date(this.dateRange[j]),y:0})
          this.dataPoints2.push({x:new Date(this.dateRange[j]),y:0})
        }
      }
      this.marketConnectChart(this.dataPoints, this.dataPoints2);
    } else if (type == 'fish' && value == 'Hatchery') {
      if (this.marketConnectgraphfilteredData.length > 0) {
        for (let i = 0; i < this.marketConnectgraphfilteredData.length; i++) {
          converted = 0;
          this.dataPoints.push({
            x: new Date(this.marketConnectgraphfilteredData[i].updatedAt),
            y: Number(this.marketConnectgraphfilteredData[i].fishHatcheriesRegistered_trial)
          });
          this.dataPoints2.push({x: new Date(this.marketConnectgraphfilteredData[i].updatedAt), y: Number(converted)});
        }
      }else{
        for(let j = 0;j < this.dateRange.length; j++){
          this.dataPoints.push({x:new Date(this.dateRange[j]),y:0})
          this.dataPoints2.push({x:new Date(this.dateRange[j]),y:0})
        }
      }
      this.marketConnectChart(this.dataPoints, this.dataPoints2);
    } else if (type == 'fish' && value == 'Farm') {
      if (this.marketConnectgraphfilteredData.length > 0) {
        for (let i = 0; i < this.marketConnectgraphfilteredData.length; i++) {
          converted = 0;
          this.dataPoints.push({
            x: new Date(this.marketConnectgraphfilteredData[i].updatedAt),
            y: Number(this.marketConnectgraphfilteredData[i].fishSeedRequested + this.marketConnectgraphfilteredData[i].fishQuoteRequested)
          });
          this.dataPoints2.push({x: new Date(this.marketConnectgraphfilteredData[i].updatedAt), y: Number(converted)});
        }
      }else{
        for(let j = 0;j < this.dateRange.length; j++){
          this.dataPoints.push({x:new Date(this.dateRange[j]),y:0})
          this.dataPoints2.push({x:new Date(this.dateRange[j]),y:0})
        }
      }
      this.marketConnectChart(this.dataPoints, this.dataPoints2);
    } else if (type == 'total' && value == 'Hatchery') {
      if (this.marketConnectgraphfilteredData.length > 0) {
        for (let i = 0; i < this.marketConnectgraphfilteredData.length; i++) {
          this.dataPoints.push({
            x: new Date(this.marketConnectgraphfilteredData[i].updatedAt),
            y: Number(this.marketConnectgraphfilteredData[i].bhDemoRequested + this.marketConnectgraphfilteredData[i].fishHatcheriesRegistered_trial + this.marketConnectgraphfilteredData[i].shrimpHatcheriesRegistered_trial)
          });
          this.dataPoints2.push({
            x:new Date(this.marketConnectgraphfilteredData[i].updatedAt),
            y: Number(this.marketConnectgraphfilteredData[i].shrimpHatcheriesRegistered_converted)
          });
        }
      }else{
        for(let j = 0; j < this.dateRange.length; j++){
          this.dataPoints.push({x:new Date(this.dateRange[j]),y:0})
          this.dataPoints2.push({x:new Date(this.dateRange[j]),y:0})
        }
      }
      this.marketConnectChart(this.dataPoints, this.dataPoints2);
    } else if (type == 'total' && value == 'Farm') {
      if (this.marketConnectgraphfilteredData.length > 0) {
        for (let i = 0; i < this.marketConnectgraphfilteredData.length; i++) {
          this.dataPoints.push({
            x: new Date(this.marketConnectgraphfilteredData[i].updatedAt),
            y: Number(this.marketConnectgraphfilteredData[i].totalSeedRequested + this.marketConnectgraphfilteredData[i].bbDemoRequested + this.marketConnectgraphfilteredData[i].farmsRegistered_trial)
          });
          this.dataPoints2.push({
            x: new Date(this.marketConnectgraphfilteredData[i].updatedAt),
            y: Number(this.marketConnectgraphfilteredData[i].farmsRegistered_converted)
          });
        }
      }else{
        for(let j = 0; j < this.dateRange.length; j++){
          this.dataPoints.push({x:new Date(this.dateRange[j]),y:0})
          this.dataPoints2.push({x:new Date(this.dateRange[j]),y:0})
        }
      }
      this.marketConnectChart(this.dataPoints, this.dataPoints2);
    }
  }

  /**
    * @method
    * @param {string} val - The selected time range ('today', 'oneweek', 'onemonth', 'oneyear').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Updates the analytics days data based on the selected time range.
    */
  public analyticsDays(val: string): void {
    this.analyticsnoOfDays = val;
    this.analyticsgetData(val);
  }

  /**
    * @method
    * @param {string} type - The type of culture to be selected ('total', 'shrimp', 'fish').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Changes the culture selection for the analytics graph and updates data accordingly.
    */
  public analyticsCultureSelection(type: string): void {
  this.analyticsCulturetype = type;
  this.analyticsMakeData(type, this.analyticsSelectionKey);
  }

  /**
    * @method
    * @param {string} type - The type of section tab to be selected.
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Changes the section tab for the analytics graph and updates data accordingly.
    */
  public analyticsSectionTab(type: string): void {
    this.analyticsSelectionKey = type;
    this.analyticsMakeData(this.analyticsCulturetype, type);
    if (type == 'Hatchery') {
      this.hatcheryName = true;
      this.farmName = false;
    } else if (type == 'Farm') {
      this.farmName = true;
      this.hatcheryName = false;
    }
  }

  /**
    * @method
    * @param {string} type - The type of time range ('today', 'oneweek', 'onemonth', 'oneyear').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Retrieves and filters data for the analytics garph based on the selected time range.
    */
  public async analyticsgetData(type: string): Promise<void> {
    try {
      this.analyticsEventsArray = [];
      this.analyticsUsersArray = [];
      let toDate = (moment(new Date()).format('YYYY-MM-DD')).toString();
      let analyticsReqBdy = {
        "reportType":"batchRun",
        "requests": [
          {
              "dateRanges": [
                  {
                      "startDate":'',
                      "endDate":toDate,
                  }
              ],
              "dimensions": [
                  {
                      "name": "eventName"
                  }
              ],
              "metrics": [
                  {
                      "name": "eventCount"
                  }
              ]
          },
          {
              "dateRanges": [
                {
                  "startDate":'',
                  "endDate":toDate,
                }
              ],
              "dimensions": [],
              "metrics": [
                  {
                      "name": "totalUsers"
                  }
              ]
          }
      ]
      }
      if (type == 'today') {
        let startDate = (moment(new Date(this.todayDate)).format('YYYY-MM-DD')).toString();
        analyticsReqBdy.requests[0].dateRanges[0].startDate = startDate;
        analyticsReqBdy.requests[1].dateRanges[0].startDate = startDate;
      } else if (type == 'oneweek') {
        let startDate = (moment(new Date(this.weekfromDate)).format('YYYY-MM-DD')).toString();
        analyticsReqBdy.requests[0].dateRanges[0].startDate = startDate;
        analyticsReqBdy.requests[1].dateRanges[0].startDate = startDate;
      } else if (type == 'onemonth') {
        let startDate = (moment(new Date(this.monthfromDate)).format('YYYY-MM-DD')).toString();
        analyticsReqBdy.requests[0].dateRanges[0].startDate = startDate;
        analyticsReqBdy.requests[1].dateRanges[0].startDate = startDate;
      } else if (type == 'oneyear') {
        let startDate = (moment(new Date(this.yearfromDate)).format('YYYY-MM-DD')).toString();
        analyticsReqBdy.requests[0].dateRanges[0].startDate = startDate;
        analyticsReqBdy.requests[1].dateRanges[0].startDate = startDate;
      }
      this.mcAnalyticsSummaryData = await this.customerLeadService.getMCAnalyticsSummary(analyticsReqBdy);
      let mcAnalyticsEventsData = this.mcAnalyticsSummaryData[0].reports[0].rows;
      for(let i =0;i<mcAnalyticsEventsData.length;i++){
        let analyticsEventsData = {
          eventName:mcAnalyticsEventsData[i].dimensionValues[0].value,
          eventCount:mcAnalyticsEventsData[i].metricValues[0].value,
        }
        this.analyticsEventsArray.push(analyticsEventsData);
      }
      if(this.analyticsEventsArray.length > 0){
        this.analyticsMakeData(this.analyticsCulturetype, this.analyticsSelectionKey);
      }
    } catch (error: any) {
      this.toastr.error(error.error?.message || error)
    }
  }

  /**
    * @method
    * @param {string} type - The type of filter ('shrimp', 'fish', or 'total').
    * @param {string} value - The value to filter by ('Farm').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Generates and filters analytics graph-related data based on the provided type and value.
   */
  public analyticsMakeData(type: string, value: string): void {
  this.analyticsfinalData = [];
  if (type == 'shrimp' && value == 'Hatchery') {
    for (let u = 0; u < this.analyticsEventsArray.length; u++) {
      let each = this.analyticsEventsArray[u];
      if (each.eventName.match(/Pl_post_seed_availability/) || each.eventName.match(/nauplii_post_seed_availability/) ||
      each.eventName.match(/pl_hatchery_register_btn/) || each.eventName.match(/nauplii_hatchery_register_btn/) || each.eventName.match(/pl_hatchery_customer_lead_register/) || each.eventName.match(/nauplii_hatchery_customer_lead_register/)) {
        this.analyticsfinalData.push(each);
      }
    }
  } else if (type == 'shrimp' && value == 'Farm') {
    for (let u = 0; u < this.analyticsEventsArray.length; u++) {
      let each = this.analyticsEventsArray[u];
      if (each.eventName.match(/pl_shrimp_request_quote/) || each.eventName.match(/nauplii_shrimp_request_quote/) ||
      each.eventName.match(/pl_requestquote_submit/) || each.eventName.match(/nauplii_requestquote_submit/) || each.eventName.match(/pl_shrimp_request_demo/) || each.eventName.match(/nauplii_shrimp_request_demo/) || each.eventName.match(/nauplii_request_demo_submit/) || each.eventName.match(/pl_request_demo_submit/)
      || each.eventName.match(/pl_post_your_requirement_submit/) || each.eventName.match(/nauplii_post_your_requirement_submit/) || each.eventName.match(/harvest_calculator_register_as_farmer/) || each.eventName.match(/harvest_calculator_request_demo/) || each.eventName.match(/harvest_calculator_estimated/) || each.eventName.match(/harvest_calculate/) || each.eventName.match(/calculator_request_demo_submit/)) {
        this.analyticsfinalData.push(each);
      }
    }

  } else if (type == 'fish' && value == 'Hatchery') {
    for (let u = 0; u < this.analyticsEventsArray.length; u++) {
      let each = this.analyticsEventsArray[u];
      if (each.eventName.match(/fingerlings_post_seed_availability/) || each.eventName.match(/spawn_post_seed_availability/) ||
      each.eventName.match(/fingerlings_hatchery_register_btn/) || each.eventName.match(/spawn_hatchery_register_btn/) || each.eventName.match(/fingerlings_hatchery_customer_lead_register/) || each.eventName.match(/spawn_hatchery_customer_lead_register/)) {
        this.analyticsfinalData.push(each);
      }
    }
  } else if (type == 'fish' && value == 'Farm') {
    for (let u = 0; u < this.analyticsEventsArray.length; u++) {
      let each = this.analyticsEventsArray[u];
      if (each.eventName.match(/fingerlings_shrimp_request_quote/) || each.eventName.match(/spawn_shrimp_request_quote/) ||
      each.eventName.match(/fingerlings_request_quote_submit/) || each.eventName.match(/spawn_request_quote_submit/) || each.eventName.match(/fingerlings_request_demo/) || each.eventName.match(/spawn_request_demo/) || each.eventName.match(/fingerlings_request_demo_submit/) || each.eventName.match(/spawn_request_demo_submit/)
      || each.eventName.match(/spawn_post_your_requirement_submit/) || each.eventName.match(/fingerlings_post_your_requirement_submit/) || each.eventName.match(/spawn_post_requriment/) || each.eventName.match(/fingerlings_post_requriment/)) {
        this.analyticsfinalData.push(each);
      }
    }
  } else if (type == 'total' && value == 'Hatchery') {
    for (let u = 0; u < this.analyticsEventsArray.length; u++) {
      let each = this.analyticsEventsArray[u];
      if (each.eventName.match(/post_seed_availability/) || each.eventName.match(/hatchery_register_btn/) || each.eventName.match(/hatchery_customer_lead_register/) ) {
        this.analyticsfinalData.push(each);
      }
    }
  } else if (type == 'total' && value == 'Farm') {
    for (let u = 0; u < this.analyticsEventsArray.length; u++) {
      let each = this.analyticsEventsArray[u];
      if (each.eventName.match(/request_quote/) || each.eventName.match(/requestquote_submit/) || each.eventName.match(/request_quote_submit/) || each.eventName.match(/request_demo/) || each.eventName.match(/request_demo_submit/) || each.eventName.match(/register_as_farmer/) || each.eventName.match(/post_your_requriment/) ||
      each.eventName.match(/post_your_requriment_submit/) || each.eventName.match(/harvest_calculator_register_as_farmer/) || each.eventName.match(/harvest_calculator_request_demo/) || each.eventName.match(/harvest_calculator_estimated/) || each.eventName.match(/harvest_calculate/) || each.eventName.match(/calculator_request_demo_submit/)) {
        this.analyticsfinalData.push(each);
      }
    }
  }
  }

  /**
    * @method
    * @param {string} val - The selected time range ('today', 'oneweek', 'onemonth', 'oneyear').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Updates the farms table data based on the selected time range.
    */
  previousFarmsTableDays: any;
  public farmstableDays(val: string): void {
    this.farmstablenoOfDays = val;
    this.clearFarmSearchInput = false;
    this.farmSearch = '';
    this.farmsfinalData = [];
    this.dispfarmsfinalData = [];
    this.isFiltering = false;
    // Store previous selection before changing
    if (val !== 'Custom') {
      this.previousFarmsTableDays = val;
    }
    this.farmstablenoOfDays = val;
    // Reset custom date values when selecting predefined ranges
    if (val !== 'Custom') {
      this.customFarmsFromDate = '';
      this.customFarmsToDate = '';
    }
    // If 'Custom' is selected, open the date range popup
    if (val === 'Custom') {
      this.isFarmsDateRangePopupOpen = true;
    } else {
      this.farmstablegetData(val);
    }
  }

  /**
    * @method
    * @param {string} type - The type of time range ('today', 'oneweek', 'onemonth', 'oneyear').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Retrieves and filters data for the farms table based on the selected time range.
    */
  public farmstablegetData(type: string): void {
    this.farmstablefilteredData = [];
    let toDate = (moment(new Date()).format('YYYY-MM-DD')).toString();
    if (type == 'today') {
      this.farmsfinalData = [];
      let startDate = new Date(this.todayDate);
      let endDate = new Date(toDate);
      this.farmstablefilteredData = this.farmscustomerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    } else if (type == 'oneweek') {
      this.farmsfinalData = [];
      let startDate = new Date(this.weekfromDate);
      let endDate = new Date(toDate);
      this.farmstablefilteredData = this.farmscustomerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    } else if (type == 'onemonth') {
      this.farmsfinalData = [];
      let startDate = new Date(this.monthfromDate);
      let endDate = new Date(toDate);
      this.farmstablefilteredData = this.farmscustomerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    } else if (type == 'oneyear') {
      this.farmsfinalData = [];
      let startDate = new Date(this.yearfromDate);
      let endDate = new Date(toDate);
      this.farmstablefilteredData = this.farmscustomerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    }
    if (this.farmstablefilteredData.length > 0) {
      this.farmsTableMakeData(this.farmstableculturetype, this.farmstableSelectionKey);
    }
  }

  public closeFarmsDateRangePopup() {
    this.isFarmsDateRangePopupOpen = false;
    // Revert back to last selected option if no custom dates are applied
    if (!this.customFarmsFromDate || !this.customFarmsToDate) {
      this.farmstablenoOfDays = this.previousFarmsTableDays;
      this.farmstablegetData(this.farmstablenoOfDays);
    } else {
      this.onFarmsDateRangeApply({
        fromDate: this.customFarmsFromDate,
        toDate: this.customFarmsToDate
      });
    }
  }

  public onFarmsDateRangeApply(event: { fromDate: string; toDate: string }) {
    this.customFarmsFromDate = event.fromDate;
    this.customFarmsToDate = event.toDate;
    this.finalData = [];
    this.dispFinalData = [];

    let startDate = new Date(this.customFarmsFromDate);
    let endDate = new Date(this.customFarmsToDate);

    // Ensure time is set correctly for accurate filtering
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    // Filter data within the custom date range safely
    this.farmstablefilteredData = this.farmscustomerLeads.filter(a => {
      if (!a.generatedDate) return false;  //Handle null or undefined dates safely

      let dateStr = a.generatedDate.split('T')[0];  // Extract only the date part
      let date = new Date(dateStr);
      date.setHours(0, 0, 0, 0);
      return date >= startDate && date <= endDate;
    });

    //  Close popup after selection
    this.isFarmsDateRangePopupOpen = false;

    if (this.farmstablefilteredData.length > 0) {
      this.farmsTableMakeData(this.farmstableculturetype, this.farmstableSelectionKey);
    }
  }

  /**
    * @method
    * @param {string} type - The type of culture to be selected ('total', 'shrimp', 'fish').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Changes the culture selection for the farms table and updates data accordingly.
    */
  public farmstableCultureSeletion(type: string): void {
    this.finalData = [];
    this.dispFinalData = [];
    this.cultureCategoryId = undefined;
    this.farmstableculturetype = type;
    this.clearFarmSearchInput = false;
    this.farmSearch = '';
    this.isFiltering = false;
    if (type == 'total') {
      this.cultureCategoryId = 'All';
    } else if (type == 'shrimp') {
      this.cultureCategoryId = 1;
    } else {
      this.cultureCategoryId = 2;
    }
    this.farmsTableMakeData(type, this.farmstableSelectionKey);
  }

  /**
    * @method
    * @param {string} type - The type of section tab to be selected.
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Changes the section tab for the farms table and updates data accordingly.
    */
  public farmstableSectionTab(type: string): void {
    this.farmstableSelectionKey = type;
    this.farmsTableMakeData(this.farmstableculturetype, type);
  }

  /**
    * @method
    * @param {string} type - The type of filter ('shrimp', 'fish', or 'total').
    * @param {string} value - The value to filter by ('Farm').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Generates and filters farm-related data based on the provided type and value.
   */
  public async farmsTableMakeData(type: string, value: string) {
    this.farmsfinalData = [];
    this.dispfarmsfinalData = [];
    if (type == 'shrimp' && value == 'Farm') {
      if (this.farmstablefilteredData.length > 0) {
        for (let u = 0; u < this.farmstablefilteredData.length; u++) {
          let each = this.farmstablefilteredData[u];
          if (each.lead_culture.name == 'Shrimp' && each.event != 'Register as hatchery' && each.event !='Register as farmer' && each.event !='Register as Food Chain Owner' && each.event !='Register as Retailer' && each.event !='Register as Middle Man' && each.event !='Register as Exporter' && each.event !='Register as dealer' && each.event !='Register as sme') {
            this.farmsfinalData.push(each);
          }
        }
      }
    } else if (type == 'fish' && value == 'Farm') {
      if (this.farmstablefilteredData.length > 0) {
        for (let u = 0; u < this.farmstablefilteredData.length; u++) {
          let each = this.farmstablefilteredData[u];
          if (each.lead_culture.name == 'Fish culture' && each.event != 'Register as hatchery' && each.event !='Register as farmer' && each.event !='Register as Food Chain Owner' && each.event !='Register as Retailer' && each.event !='Register as Middle Man' && each.event !='Register as Exporter' && each.event !='Register as dealer' && each.event !='Register as sme') {
            this.farmsfinalData.push(each);
          }
        }
      }
    } else if (type == 'total' && value == 'Farm') {
      if (this.farmstablefilteredData.length > 0) {
        for (let u = 0; u < this.farmstablefilteredData.length; u++) {
          let each = this.farmstablefilteredData[u];
          if (each.lead_from == 'Farmer' && each.event !='Register as FoodChain Owner' && each.event !='Register as Retailer' && each.event !='Register as Middle Man' && each.event !='Register as FoodChain Owner' && each.event !='Register as Exporter' && each.event !='Register as dealer' && each.event !='Register as sme') {
            this.farmsfinalData.push(each);
          }
        }
      }
    }
    this.initializeBatchLoader(); // Reset instance
    this.batchLoader.reset();     // Clear state
    await this.batchLoader.loadNextBatch(true); // Load first batch
  }


  /**
   * @method
   * @param {string} val - The selected time range ('today', 'oneweek', 'onemonth', 'oneyear').
   * @returns {void} This function does not return a value.
   * Description:
   * This method is used to Updates the farms table data based on the selected time range.
   */
  previousBuyerTableDays: any;
  public buyerstableDays(val: string): void {
    this.buyerfinalData = [];
    this.dispbuyerfinalData = [];
    this.buyertablenoOfDays = val;
    this.clearBuyerSearchInput = false;
    this.isFiltering = false;
    this.buyerSearch = '';
    if (val !== 'Custom') {
      this.previousBuyerTableDays = val;
    }
    this.buyertablenoOfDays = val;
    // Reset custom date values when selecting predefined ranges
    if (val !== 'Custom') {
      this.customBuyerFromDate = '';
      this.customBuyerToDate = '';
    }
    // If 'Custom' is selected, open the date range popup
    if (val === 'Custom') {
      this.isBuyerDateRangePopupOpen = true;
    } else {
      this.buyertablegetData(val);
    }
  }

  /**
   * @method
   * @param {string} type - The type of time range ('today', 'oneweek', 'onemonth', 'oneyear').
   * @returns {void} This function does not return a value.
   * Description:
   * This method is used to Retrieves and filters data for the farms table based on the selected time range.
   */
  public buyertablegetData(type: string): void {
    this.buyertablefilteredData = [];
    let toDate = (moment(new Date()).format('YYYY-MM-DD')).toString();
    if (type == 'today') {
      let startDate = new Date(this.todayDate);
      let endDate = new Date(toDate);
      this.buyertablefilteredData = this.buyerscustomerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    } else if (type == 'oneweek') {
      let startDate = new Date(this.weekfromDate);
      let endDate = new Date(toDate);
      this.buyertablefilteredData = this.buyerscustomerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    } else if (type == 'onemonth') {
      let startDate = new Date(this.monthfromDate);
      let endDate = new Date(toDate);
      this.buyertablefilteredData = this.buyerscustomerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    } else if (type == 'oneyear') {
      let startDate = new Date(this.yearfromDate);
      let endDate = new Date(toDate);
      this.buyertablefilteredData = this.buyerscustomerLeads.filter(a => {
        if (a.generatedDate != null) {
          let date = new Date(a.generatedDate.split('T')[0]);
          return (date >= startDate && date <= endDate);
        }
      });
    }
    if (this.buyertablefilteredData.length > 0) {
      this.buyerTableMakeData(this.buyertableculturetype, this.buyertableSelectionKey);
    }
  }

  public closeBuyerDateRangePopup() {
    this.isBuyerDateRangePopupOpen = false;
    // Revert back to last selected option if no custom dates are applied
    if (!this.customBuyerFromDate || !this.customBuyerToDate) {
      this.buyertablenoOfDays = this.previousBuyerTableDays;
      this.buyertablegetData(this.buyertablenoOfDays);
    } else {
      this.onBuyerDateRangeApply({
        fromDate: this.customBuyerFromDate,
        toDate: this.customBuyerToDate
      });
    }
  }

  public onBuyerDateRangeApply(event: { fromDate: string; toDate: string }) {
    this.buyerfinalData = [];
    this.dispbuyerfinalData = [];
    this.customBuyerFromDate = event.fromDate;
    this.customBuyerToDate = event.toDate;

    let startDate = new Date(this.customBuyerFromDate);
    let endDate = new Date(this.customBuyerToDate);

    // Ensure time is set correctly for accurate filtering
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    // Filter data within the custom date range safely
    this.buyertablefilteredData = this.buyerscustomerLeads.filter(a => {
      if (!a.generatedDate) return false;  //Handle null or undefined dates safely

      let dateStr = a.generatedDate.split('T')[0];  // Extract only the date part
      let date = new Date(dateStr);
      date.setHours(0, 0, 0, 0);
      return date >= startDate && date <= endDate;
    });

    //  Close popup after selection
    this.isHatcheryDateRangePopupOpen = false;
    if (this.buyertablefilteredData.length > 0) {
      this.buyerTableMakeData(this.buyertableculturetype, this.buyertableSelectionKey);
    }
  }

  /**
   * @method
   * @param {string} type - The type of culture to be selected ('total', 'shrimp', 'fish').
   * @returns {void} This function does not return a value.
   * Description:
   * This method is used to Changes the culture selection for the farms table and updates data accordingly.
   */
  public buyertableCultureSeletion(type: string): void {
    this.cultureCategoryId = undefined;
    this.buyertableculturetype = type;
    this.clearBuyerSearchInput = false;
    this.buyerfinalData = [];
    this.dispbuyerfinalData = [];
    this.isFiltering = false;
    this.buyerSearch = '';
    if (type == 'total') {
      this.cultureCategoryId = 'All';
    } else if (type == 'shrimp') {
      this.cultureCategoryId = 1;
    } else {
      this.cultureCategoryId = 2;
    }
    this.buyerTableMakeData(type, this.buyertableSelectionKey);
  }

  /**
   * @method
   * @param {string} type - The type of section tab to be selected.
   * @returns {void} This function does not return a value.
   * Description:
   * This method is used to Changes the section tab for the farms table and updates data accordingly.
   */
  public buyertableSectionTab(type: string): void {
    this.buyertableSelectionKey = type;
    this.buyerTableMakeData(this.buyertableculturetype, type);
  }

  /**
   * @method
   * @param {string} type - The type of filter ('shrimp', 'fish', or 'total').
   * @param {string} value - The value to filter by ('Farm').
   * @returns {void} This function does not return a value.
   * Description:
   * This method is used to Generates and filters farm-related data based on the provided type and value.
   */
  public async buyerTableMakeData(type: string, value: string) {
    this.buyerfinalData = [];
    this.dispbuyerfinalData = [];
    if (type == 'shrimp' && value == 'Buyer') {
      if (this.buyertablefilteredData.length > 0) {
        for (let u = 0; u < this.buyertablefilteredData.length; u++) {
          let each = this.buyertablefilteredData[u];
          if (each.lead_culture.name == 'Shrimp' && (each.event == 'Interested in Shrimp stock' || each.event == 'Post Shrimp Stock Request')) {
            this.buyerfinalData.push(each);
          }
        }
      }
    } else if (type == 'fish' && value == 'Buyer') {
      if (this.buyertablefilteredData.length > 0) {
        for (let u = 0; u < this.buyertablefilteredData.length; u++) {
          let each = this.buyertablefilteredData[u];
          if (each.lead_culture.name == 'Fish culture' && (each.event == 'Interested in Fish stock' || each.event == 'Post Fish Stock Request')) {
            this.buyerfinalData.push(each);
          }

          // if (each.event == 'Register as Retailer' || each.event == 'Register as Exporter' || each.event == 'Register as Middle Man'
          //   || each.event == 'Food Chain Owner' || each.event == 'Post Shrimp Stock Request' || each.event == 'Post Fish Stock Request'
          //   || each.event == 'Interested in Shrimp stock' || each.event == 'Interested in Fish stock') {
          // }
        }
      }
    } else if (type == 'total' && value == 'Buyer') {
      if (this.buyertablefilteredData.length > 0) {
        for (let u = 0; u < this.buyertablefilteredData.length; u++) {
          let each = this.buyertablefilteredData[u];
          if (each.lead_from == 'Middleman/Agent/Broker' || each.event == 'Register as Retailer' || each.event == 'Register as Exporter' || each.event == 'Register as Middle Man' || each.event == 'Register as Food Chain Owner' || each.event == 'Post Fish Stock Request' || each.event == 'Post Shrimp Stock Request' || each.event == 'Interested in Shrimp stock' || each.event == 'Interested in Fish stock') {
            this.buyerfinalData.push(each);
          }
        }
      }
    }
    this.initializeBatchLoader(); // Reset instance
    this.batchLoader.reset();     // Clear state
    await this.batchLoader.loadNextBatch(true); // Load first batch
  }

  /**
    * @method
    * @param {string} type - The type of box shadow to apply ('total', 'shrimp', or 'fish').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to Changes the color of specified elements based on the given type.
    */
  public changeColor(type: string): void {
    if (type == 'total') {
      $(document).ready(function() {
        $('.count, .leadcount, .convertcount, .readingsdays').css({'color': '#5A5F7D'});
      });
    } else if (type == 'shrimp') {
      $(document).ready(function() {
        $('.count, .leadcount, .convertcount, .readingsdays').css({'color': '#008080'});
      });
    } else if (type == 'fish') {
      $(document).ready(function() {
        $('.count, .leadcount, .convertcount, .readingsdays').css({'color': '#0ABDE3'});
      });
    }
  }

  /**
    * @method
    * @param {string} type - The type of box shadow to apply ('total', 'shrimp', or 'fish').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to adds a box shadow to the hatchery card container based on the specified type.
    */
  public addBoxSahadow(type: string): void {
    if (type == 'total') {
      $(document).ready(function() {
        $('.card-container').css({'box-shadow': '0px 5px 15px #9299B82E'});
      });
    } else if (type == 'shrimp') {
      $(document).ready(function() {
        $('.card-container').css({'box-shadow': '0px 5px 15px #008080'});
      });
    } else if (type == 'fish') {
      $(document).ready(function() {
        $('.card-container').css({'box-shadow': '0px 0px 15px #0ABDE3'});
      });
    }
  }

  /**
    * @method
    * @param {string} type - The type of box shadow to apply ('total', 'shrimp', or 'fish').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to adds a box shadow to the market connect card container based on the specified type.
    */
  public marketconnectaddBoxSahadow(type: string): void {
    if (type == 'total') {
      $(document).ready(function() {
        $('.marketcard-container').css({'box-shadow': '0px 5px 15px #9299B82E'});
      });
    } else if (type == 'shrimp') {
      $(document).ready(function() {
        $('.marketcard-container').css({'box-shadow': '0px 5px 15px #008080'});
      });
    } else if (type == 'fish') {
      $(document).ready(function() {
        $('.marketcard-container').css({'box-shadow': '0px 0px 15px #0ABDE3'});
      });
    }
  }

  /**
    * @method
    * @param {string} type - The type of box shadow to apply ('total', 'shrimp', or 'fish').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to adds a box shadow to the market connect graph card container based on the specified type.
    */
  public marketconnectGraphaddBoxSahadow(type: string): void {
    if (type == 'total') {
      $(document).ready(function() {
        $('.marketgraphcard-container').css({'box-shadow': '0px 5px 15px #9299B82E'});
      });
    } else if (type == 'shrimp') {
      $(document).ready(function() {
        $('.marketgraphcard-container').css({'box-shadow': '0px 5px 15px #008080'});
      });
    } else if (type == 'fish') {
      $(document).ready(function() {
        $('.marketgraphcard-container').css({'box-shadow': '0px 0px 15px #0ABDE3'});
      });
    }
  }

  /**
    * @method
    * @param {string} type - The type of box shadow to apply ('total', 'shrimp', or 'fish').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to adds a box shadow to the analytics card container based on the specified type.
    */
  public analyticsBoxSahadow(type: string): void {
    if (type == 'total') {
      $(document).ready(function() {
        $('.analytics-container').css({'box-shadow': '0px 5px 15px #9299B82E'});
      });
    } else if (type == 'shrimp') {
      $(document).ready(function() {
        $('.analytics-container').css({'box-shadow': '0px 5px 15px #008080'});
      });
    } else if (type == 'fish') {
      $(document).ready(function() {
        $('.analytics-container').css({'box-shadow': '0px 0px 15px #0ABDE3'});
      });
    }
  }

  /**
    * @method
    * @param {string} type - The type of box shadow to apply ('total', 'shrimp', or 'fish').
    * @returns {void} This function does not return a value.
    * Description:
    * This method is used to adds a box shadow to the farms card container based on the specified type.
    */
  public farmsaddBoxSahadow(type: string): void {
    if (type == 'total') {
      $(document).ready(function() {
        $('.farmscard-container').css({'box-shadow': '0px 5px 15px #9299B82E'});
      });
    } else if (type == 'shrimp') {
      $(document).ready(function() {
        $('.farmscard-container').css({'box-shadow': '0px 5px 15px #008080'});
      });
    } else if (type == 'fish') {
      $(document).ready(function() {
        $('.farmscard-container').css({'box-shadow': '0px 0px 15px #0ABDE3'});
      });
    }
  }

  /**
    * @method
    * @returns {void} This function does not return a value.
    * @param {KeyboardEvent} event - The keyboard event that triggered the search.
    * Description:
    * This function handles real-time Leads (i.e Hatchery, Farm and Market Connect) searching (i.e lead mobile number, lead event and lead status) by filtering and updating displayed Leads
    * based on input criteria, while managing UI elements for search results and clearing.
    */
  public async searchLead(type: string) {
    if (type == 'hatcheries') {
      const query = this.hatcherySearch?.replace(/[-_]|\s/g,"").trim().toLowerCase() || '';
      this.isFiltering = query.length > 0;

      if (this.isFiltering) {
        this.clearHatcherySearchInput = true;
        this.dispFinalData = this.finalData.filter(hatchery =>
          hatchery.mobileNumber?.replace(/[-_]|\s/g,"").toLowerCase().startsWith(query) ||
          hatchery.event?.replace(/[-_]|\s/g,"").toLowerCase().startsWith(query) ||
          hatchery.status?.replace(/[-_]|\s/g,"").toLowerCase().startsWith(query)
        )
      } else {
        this.clearHatcherySearchInput = false;
        this.isFiltering = false;
        this.initializeBatchLoader();
        this.batchLoader?.reset();
        await this.batchLoader?.loadNextBatch();
      }
    } else if (type == 'farms') {
      const query = this.farmSearch?.replace(/[-_]|\s/g,"").trim().toLowerCase() || '';
      this.isFiltering = query.length > 0;

      if (this.isFiltering) {
        this.clearFarmSearchInput = true;
        this.dispfarmsfinalData = this.farmsfinalData.filter(farm =>
          farm.mobileNumber?.replace(/[-_]|\s/g,"").toLowerCase().startsWith(query) ||
          farm.event?.replace(/[-_]|\s/g,"").toLowerCase().startsWith(query) ||
          farm.status?.replace(/[-_]|\s/g,"").toLowerCase().startsWith(query)
        )
      } else {
        this.clearFarmSearchInput = false;
        this.isFiltering = false;
        this.initializeBatchLoader();
        this.batchLoader?.reset();
        await this.batchLoader?.loadNextBatch();
      }
    } else if (type == 'marketconnect') {
      const query = this.marketConnectSearch?.replace(/[-_]|\s/g,"").trim().toLowerCase() || '';
      this.isFiltering = query.length > 0;

      if (this.isFiltering) {
        this.clearMCSearchInput = true;
        this.dispmarketconnectfinalData = this.marketconnectfinalData.filter(mc =>
          mc.businessName?.replace(/[-_]|\s/g,"").toLowerCase().startsWith(query) ||
          mc.farmSiteName?.replace(/[-_]|\s/g,"").toLowerCase().startsWith(query) ||
          mc.event?.replace(/[-_]|\s/g,"").toLowerCase().startsWith(query) ||
          mc.status?.replace(/[-_]|\s/g,"").toLowerCase().startsWith(query) ||
          mc.mobileNumber?.replace(/[-_]|\s/g,"").toLowerCase().startsWith(query)
        )
      } else {
        this.clearMCSearchInput = false;
        this.isFiltering = false;
        this.initializeBatchLoader();
        this.batchLoader?.reset();
        await this.batchLoader?.loadNextBatch();
      }
    } else if (type == 'buyer') {
      const query = this.buyerSearch?.replace(/[-_]|\s/g,"").trim().toLowerCase() || '';
      this.isFiltering = query.length > 0;

      if (this.isFiltering) {
        this.clearBuyerSearchInput = true;
        this.dispbuyerfinalData = this.buyerfinalData.filter(buyer =>
          buyer.mobileNumber?.replace(/[-_]|\s/g,"").toLowerCase().startsWith(query) ||
          buyer.event?.replace(/[-_]|\s/g,"").toLowerCase().startsWith(query) ||
          buyer.status?.replace(/[-_]|\s/g,"").toLowerCase().startsWith(query)
        )
      } else {
        this.clearBuyerSearchInput = false;
        this.isFiltering = false;
        this.initializeBatchLoader();
        this.batchLoader?.reset();
        await this.batchLoader?.loadNextBatch();
      }
    }
  }

  /**
    * @async
    * @method
    * @param {string} id - The ID of the customer lead.
    * @param {string} event - The type of status action event.
    * @param {string} type - The type of status action (follow, close, assigned, archive).
    * @param {string} val - The value indicating the type of card (hatchery, marketconnect, farms).
    * @param {number} i - The index of the selected item in the data array.
    * @returns {Promise<void>} A Promise that resolves when the modal dialog is successfully opened, or when an error occurs.
    * Description:
    * This method is used to Handles different status actions for customer leads. Opens modal dialogs for different status actions (follow, close, assigned, archive)
    * and initializes necessary data for the selected action.
    */
  public async statusAction(id: string, event: string, type: string, val: string, i: number): Promise<void> {
    try {
      if (type == 'follow') {
        $('#actionModal').modal({
          backdrop: 'static',
          keyboard: false,
          show: true
        });
      } else if (type == 'close') {
        $('#closeactionModal').modal({
          backdrop: 'static',
          keyboard: false,
          show: true
        });
      } else if (type == 'assigned') {
        $('#assignactionModal').modal({
          backdrop: 'static',
          keyboard: false,
          show: true
        });
        this.persons = await this.personsService.getAllPersons();
        if(this.persons && this.persons.length > 0){
          this.persons = this.persons.filter(person => person.personType[0].personRoleID == '630c4d39f4bcf9001e52805e');
        }
      } else if (type == 'archive') {
        $('#archiveactionModal').modal({
          backdrop: 'static',
          keyboard: false,
          show: true
        });
      }
      this.selectedcard = val;
      if (val == 'hatchery') {
        this.selectedItem = this.finalData.find(fromhatchery => fromhatchery && fromhatchery.id == id);
      }
      if (val == 'marketconnect') {
        this.selectedItem = this.marketconnectfinalData.find(fromhatchery => fromhatchery && fromhatchery.id == id);
      }
      if (val == 'farms') {
        this.selectedItem = this.farmsfinalData.find(fromhatchery => fromhatchery && fromhatchery.id == id);
      }
      if (val == 'buyer') {
        this.selectedItem = this.buyerfinalData.find(fromhatchery => fromhatchery && fromhatchery.id == id);
      }
      if (this.selectedItem.status == 'FollowUp' || this.selectedItem.status == 'Closed') {
        let updatedAt = this.selectedItem.status_date;
        if (updatedAt) {
          let time = moment(updatedAt.split('T')[1], 'HH:mm:ss').add(330, 'minutes').format('hh:mm:ss A');
          let date = moment(updatedAt.split('T')[0]);
          this.selectedItem.status_date = moment(date).format('DD-MMM-YYYY') + ' ' + time;
        }
      }
      this.mobileNumber = this.selectedItem.mobileNumber;
      this.currentDate = moment(new Date()).format('DD-MMM-YYYY hh:mm A');
      this.selectedIndex = i;
      this.selectedEvent = event;
    } catch (error: any) {
      this.toastr.error(error.error?.message || error)
    }
  }

  /**
    * @method
    * Description:
    * Shortcut to access form controls for convenient validation.
    */
  public get f() {
    return this.followupForm.controls;
  }

  /**
    * @method
    * Description:
    * Shortcut to access form controls for convenient validation.
    */
  public get f1() {
    return this.closeForm.controls;
  }

  /**
    * @method
    * Description:
    * Shortcut to access form controls for convenient validation.
    */
  public get f2() {
    return this.assignedForm.controls;
  }

  /**
    * @method
    * @async
    * @returns {Promise<void>} A Promise that resolves when the customer lead's status is successfully set to 'FollowUp', or when an error occurs.
    * @throws {Error} If an error occurs during the retrieval process.
    * Description:
    * This method is used to Sets a customer lead's status to 'FollowUp' and updates related properties. This function updates the status, status date, by calling
    * updateOneById method which is in the common {@link Service} file and other properties of the customer lead to indicate that a follow-up is required.
    */
  public async followUp(): Promise<void> {
    this.followupSubmitted = true;
    // stop here if form is invalid // need to check with anusha
    if (this.followupForm.invalid) {
      return;
    }
    this.customerLead.id = this.selectedItem.id;
    this.customerLead.status = 'FollowUp';
    this.customerLead.status_date = new Date();
    this.customerLead.updatedBy = localStorage.personID;
    try {
      const { id, ...updateCustomerLead } = this.customerLead;
      await this.customerLeadService.updateOneByID(this.customerLead.id, updateCustomerLead);
      $('#actionModal').modal('hide');
      this.followupSubmitted = false;
      this.customerLead.status_remarks = updateCustomerLead.status_remarks;
      if (this.selectedcard == 'hatchery') {
        this.finalData[this.selectedIndex].status = this.customerLead.status;
        this.finalData[this.selectedIndex].status_remarks = this.customerLead.status_remarks;
      } else if (this.selectedcard == 'marketconnect') {
        this.marketconnectfinalData[this.selectedIndex].status = this.customerLead.status;
        this.marketconnectfinalData[this.selectedIndex].status_remarks = this.customerLead.status_remarks;
      } else if (this.selectedcard == 'farms') {
        this.farmsfinalData[this.selectedIndex].status = this.customerLead.status;
        this.farmsfinalData[this.selectedIndex].status_remarks = this.customerLead.status_remarks;
      } else if (this.selectedcard == 'buyer') {
        this.buyerfinalData[this.selectedIndex].status = this.customerLead.status;
        this.buyerfinalData[this.selectedIndex].status_remarks = this.customerLead.status_remarks;
      }
      this.customerLead.status_remarks = undefined;
    } catch (error: any) {
      this.toastr.error(error.error?.message || error)
    }
  }

  /**
    * @method
    * @async
    * @returns {Promise<void>} A Promise that resolves when the customer lead is successfully closed, or when an error occurs.
    * @throws {Error} If an error occurs during the retrieval process.
    * Description:
    * This method is used to Closes a customer lead by updating its status to 'Closed'. This function updates the status by calling
    * updateOneById method which is in the common {@link Service} file and related properties of the customer lead. It also updates the UI to reflect the closed status.
    */
  public async leadClose(): Promise<void> {
    this.closeSubmitted = true;
    // stop here if form is invalid // need to check with anusha
    if (this.closeForm.invalid) {
      return;
    }
    this.customerLead.id = this.selectedItem.id;
    this.customerLead.status = 'Closed';
    this.customerLead.status_date = new Date();
    this.customerLead.updatedBy = localStorage.personID;
    try {
      const { id, ...updateCustomerLead } = this.customerLead;
      await this.customerLeadService.updateOneByID(this.customerLead.id, updateCustomerLead);
      $('#closeactionModal').modal('hide');
      this.closeSubmitted = false;
      this.customerLead.converted = false;
      this.customerLead.status_remarks = undefined;
      if (this.selectedcard == 'hatchery') {
        this.finalData.splice(this.selectedIndex, 1);
        this.customerLeads = this.customerLeads.filter(hatcheryLead => hatcheryLead.id != this.selectedItem.id);
        this.tablegetData(this.tablenoOfDays);
      } else if (this.selectedcard == 'marketconnect') {
        this.marketconnectfinalData.splice(this.selectedIndex, 1);
        this.marketConnectCustomerLeads = this.marketConnectCustomerLeads.filter(marketConnectLead => marketConnectLead.id != this.selectedItem.id);
        this.marketconnecttableDays(this.marketconnecttablenoOfDays);
      } else if (this.selectedcard == 'farms') {
        this.farmsfinalData.splice(this.selectedIndex, 1);
        this.farmscustomerLeads = this.farmscustomerLeads.filter(farmLead => farmLead.id != this.selectedItem.id);
        this.farmstablegetData(this.farmstablenoOfDays);
      } else if (this.selectedcard == 'buyer') {
        this.buyerfinalData.splice(this.selectedIndex, 1);
        this.buyerscustomerLeads = this.buyerscustomerLeads.filter(buyerLead => buyerLead.id != this.selectedItem.id);
        this.buyertablegetData(this.buyertablenoOfDays);
      }
    } catch (error: any) {
      this.toastr.error(error.error?.message || error)
    }
  }

  /**
    * @method
    * @async
    * @returns {Promise<void>} A Promise that resolves when the customer lead is successfully assigned, or when an error occurs.
    * @throws {Error} If an error occurs during the retrieval process.
    * Description:
    * This method is used to Assigns a customer lead to a specific person and updates its status to 'Assigned'. This function updates the assigned person by calling
    * updateOneById method which is in the common {@link Service} file and related properties of the customer lead. It also updates the UI to reflect the assigned status.
    */
  public async assigned(): Promise<void> {
    this.assignedSubmitted = true;
    // stop here if form is invalid // need to check with anusha
    if (this.assignedForm.invalid) {
      return;
    }
    const customer = this.persons.find(person => person && person.id == this.assignedId);
    if (!customer) {
      this.toastr.error('Please select a valid assignee.');
      return;
    }
    this.customerLead.id = this.selectedItem.id;
    this.customerLead.status_date = new Date();
    this.customerLead.assigned_to = {
      id: customer.id,
      name: customer.firstName + ' ' + customer.lastName
    };
    this.customerLead.status = 'Assigned';
    this.customerLead.status_remarks = '';
    this.customerLead.updatedBy = localStorage.personID;
    try {
      const { id, ...updateCustomerLead } = this.customerLead;
      await this.customerLeadService.updateOneByID(this.customerLead.id, updateCustomerLead);
      $('#assignactionModal').modal('hide');
      this.assignedSubmitted = false;
      this.assignedId = undefined;
      if (this.selectedcard == 'hatchery') {
        this.finalData[this.selectedIndex].status = this.customerLead.status;
        this.finalData[this.selectedIndex].status_remarks = this.customerLead.status_remarks;
      } else if (this.selectedcard == 'marketconnect') {
        this.marketconnectfinalData[this.selectedIndex].status = this.customerLead.status;
        this.marketconnectfinalData[this.selectedIndex].status_remarks = this.customerLead.status_remarks;
      } else if (this.selectedcard == 'farms') {
        this.farmsfinalData[this.selectedIndex].status = this.customerLead.status;
        this.farmsfinalData[this.selectedIndex].status_remarks = this.customerLead.status_remarks;
      } else if (this.selectedcard == 'buyer') {
        this.buyerfinalData[this.selectedIndex].status = this.customerLead.status;
        this.buyerfinalData[this.selectedIndex].status_remarks = this.customerLead.status_remarks;
      }
    } catch (error: any) {
      this.toastr.error(error.error?.message || error)
    }
  }

  /**
    * @method
    * @async
    * @returns {Promise<void>} A Promise that resolves when the customer lead is archived successfully, or when an error occurs.
    * @throws {Error} If an error occurs during the retrieval process.
    * Description:
    * This method is used to Archives the selected customer lead by updating its status to 'Archived'. This function updates the status by calling
    * updateOneById method which is in the common {@link Service} file and other relevant properties
    * of the customer lead. It also updates the UI to reflect the archived status.
    */
  public async archiveYes(): Promise<void> {
    this.customerLead.id = this.selectedItem.id;
    this.customerLead.status = 'Archived';
    this.customerLead.status_remarks = '';
    this.customerLead.status_date = new Date();
    this.customerLead.updatedBy = localStorage.personID;
    try {
      const { id, ...updateCustomerLead } = this.customerLead;
      await this.customerLeadService.updateOneByID(this.customerLead.id, updateCustomerLead);
      $('#archiveactionModal').modal('hide');
      if (this.selectedcard == 'hatchery') {
        this.finalData.splice(this.selectedIndex, 1);
        this.customerLeads = this.customerLeads.filter(hatcheryLead => hatcheryLead.id != this.selectedItem.id);
        this.tablegetData(this.tablenoOfDays);
      } else if (this.selectedcard == 'marketconnect') {
        this.marketconnectfinalData.splice(this.selectedIndex, 1);
        this.marketConnectCustomerLeads = this.marketConnectCustomerLeads.filter(marketConnectLead => marketConnectLead.id != this.selectedItem.id);
        this.marketconnecttableDays(this.marketconnecttablenoOfDays);
      } else if (this.selectedcard == 'farms') {
        this.farmsfinalData.splice(this.selectedIndex, 1);
        this.farmscustomerLeads = this.farmscustomerLeads.filter(farmLead => farmLead.id != this.selectedItem.id);
        this.farmstablegetData(this.farmstablenoOfDays);
      }  else if (this.selectedcard == 'buyer') {
        this.buyerfinalData.splice(this.selectedIndex, 1);
        this.buyerscustomerLeads = this.buyerscustomerLeads.filter(buyerLead => buyerLead.id != this.selectedItem.id);
        this.buyertablegetData(this.buyertablenoOfDays);
      }
    } catch (error: any) {
      this.toastr.error(error.error?.message || error)
    }
  }

  /**
    * @method
    * @returns {void} This function does not return any value.
    * Description:
    * This method is used to Closes the archive action modal.
    */
  public archiveNo(): void {
    $('#archiveactionModal').modal('hide');
  }

  /**
    * @method
    * @returns {void} This function does not return any value.
    * Description:
    * This method is used to Opens the specified element in fullscreen mode if the browser supports it.
    */
  public openFullScreen(type: any): void {
    if (type == 'hatcheryCardContainer') {
      let element = document.getElementById('hatcheryCardContainer') as HTMLElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      }
    }
    if (type == 'marketCardContainer') {
      let element = document.getElementById('marketCardContainer') as HTMLElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      }
    }
    if (type == 'marketcardgraph') {
      let element = document.getElementById('marketcardgraph') as HTMLElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      }
    }
    if (type == 'googleanalytics') {
      let element = document.getElementById('googleanalytics') as HTMLElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      }
    }
    if (type == 'farmsCardContainer') {
      let element = document.getElementById('farmsCardContainer') as HTMLElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      }
    }
    if (type == 'buyerCardContainer') {
      let element = document.getElementById('buyerCardContainer') as HTMLElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      }
    }
  }

  /**
    * @method
    * @returns {void} This function does not return any value.
    * Description:
    * This method is used to Closes the fullscreen mode if the current document supports it.
    */
  public closeFullScreen(): void {
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    }
  }

  /**
    * @method
    * @param {string} type - The type of report to generate and export.
    * @returns {void} A Promise that resolves when the Excel report is generated and exported, or when an error occurs.
    * Description:
    * This method is used to Generates and exports an Excel report based on the specified type (Hatcheries Report, Market Connect Report, or Farms Report).
    */
  public exportExcel(type: string): void {
    let currentDate = moment(new Date()).format('DD MMM YYYY hh:mm')+ ' ' +  (new Date().getHours() >= 12 ? 'PM' : 'AM');
    if (this.loginPersonType == 'EMPLOYEE') {
      this.loginUserBusinessName = 'Ambrotechs Private Ltd';
    }
    this.leadsExcelObj = {
      cultureCategory: this.cultureCategoryId,
      generatedTime: currentDate,
      login:{
        role: this.loginPersonType,
        businessName: this.loginUserBusinessName,
        location: this.businessEntity?.address?.[0]?.city ?? (this.businessEntity?.address?.[0]?.district ?? (this.businessEntity?.address?.[0]?.state ?? '')),
        mobileNumber: this.businessEntity?.mobileNumber ?? ''
      },
      status: [],
      hatcheryReport: false,
    }
    if (type == 'Hatcheries Report') {
        this.leadsExcelObj.report = type;
        this.leadsExcelObj.businessType = this.tableSelectionKey;
        this.leadsExcelObj.status = ['Open', 'FollowUp', 'Assigned'];
        this.leadsExcelObj.hatcheryReport = true;
        if (this.tablenoOfDays != 'Custom') {
          this.leadsExcelObj.date = this.tablenoOfDays;
        } else {
          this.leadsExcelObj.date = {
            fromDate: moment(this.customHatcheryFromDate).format('YYYY-MM-DD'),
            toDate: moment(this.customHatcheryToDate).format('YYYY-MM-DD')
          }
        }
    } else if (type == 'Market Connect Report') {
        this.leadsExcelObj.report = type;
        this.leadsExcelObj.status = ['Open', 'FollowUp', 'Assigned']
        this.leadsExcelObj.businessType = this.marketconnecttableSelectionKey == 'Buyer' ? 'External Business' : this.marketconnecttableSelectionKey;
        if (this.marketconnecttablenoOfDays != 'Custom') {
          this.leadsExcelObj.date = this.marketconnecttablenoOfDays;
        } else {
          this.leadsExcelObj.date = {
            fromDate: moment(this.customMCREPFromDate).format('YYYY-MM-DD'),
            toDate: moment(this.customMCREPToDate).format('YYYY-MM-DD')
          }
        }
    } else if(type == 'Farms Report') {
        this.leadsExcelObj.report = type;
        this.leadsExcelObj.businessType = this.farmstableSelectionKey;
        this.leadsExcelObj.status = ['Open', 'FollowUp', 'Assigned']
        if (this.farmstablenoOfDays != 'Custom') {
          this.leadsExcelObj.date = this.farmstablenoOfDays;
        } else {
          this.leadsExcelObj.date = {
            fromDate: moment(this.customFarmsFromDate).format('YYYY-MM-DD'),
            toDate: moment(this.customFarmsToDate).format('YYYY-MM-DD')
          }
        }
    } else if(type == 'Buyer Report') {
      this.leadsExcelObj.report = 'Market Connect Report';
      this.leadsExcelObj.businessType = 'External Business';
      this.leadsExcelObj.status = ['Open', 'FollowUp', 'Assigned']
      if (this.buyertablenoOfDays != 'Custom') {
        this.leadsExcelObj.date = this.buyertablenoOfDays;
      } else {
        this.leadsExcelObj.date = {
          fromDate: moment(this.customBuyerFromDate).format('YYYY-MM-DD'),
          toDate: moment(this.customBuyerToDate).format('YYYY-MM-DD')
        }
      }
    }
    try {
      const fileObj = this.customerLeadService.excelReportsDownload('amcReports', this.leadsExcelObj);
      fileObj.subscribe(fileblob => {
        if (fileblob) {
          this.excelService.saveAsExcelFile(fileblob, 'Market Connect Report');
        }
      })
    } catch (error: any) {
      this.toastr.error(error.error?.message || error)
    }
  }

  /**
    * @method
    * @returns {void} This function does not return any value.
    * Description:
    * This method is used to Generates and prepares content for an email to be sent. This function may contain code related to email content generation or modification.
    * It might open a new window to trigger the email client with the generated content. Actual email sending is not handled within this function.
    */
  public mail_content(): void {
    /*let tableContent = document.getElementById("cartcontent").innerHTML;
    'tableContent', tableContent)
    let mBody = "" + tableContent + "";
    'mBody', mBody)
    let mail = "mailto:info@iprotechs.com?subject=Titel&body=" + mBody;
    // document.location.href = "mailto:test@domain.com?subject=Titel&body=" + mBody;
    // let mail = document.location
    window.open(mail);*/
    /*var blob = new Blob([document.getElementById('exportable').innerHTML], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"

    });
    var i = (new Date().toJSON().slice(0, 10)) + "_" + "Report.xls";
    saveAs(blob, i);*/
    /*var emailId ="abc@gmail.com"
    var ccEmail ="xyz@gmail.com"
    var subject ="testing"
    // var body= "<table><tr><td>Nbr</td><td>Name</td></tr></table>"
    var body= document.getElementById("cartcontent").innerHTML;
    'body', body)

    window.location.href = "mailto:" + emailId + "?cc=" + ccEmail + "&subject=" +
      subject + "&body=" + body;
    window.open(window.location.href);*/
    const cartContent = document.getElementById('cartcontent');
    if (!cartContent) {
      return;
    }

    const tableContent = cartContent.innerHTML;
    const mBody = '<html><body><table>' + tableContent + '</table></body></html>';
    alert(mBody);
  }

  /**
    * @method
    * @returns {void} This function does not return any value.
    * Description:
    * This method is used to Closes the popup by resetting selected event, customer lead converted status, status remarks, and assigned ID.
    */
  public closePopup(): void {
    this.selectedEvent = '';
    this.customerLead.converted = false;
    this.customerLead.status_remarks = undefined;
    this.assignedId = undefined;
  }

  /**
    * @method
    * @param {number} pageNum - The new page number to set as active.
    * @param {string} type - The type of data for which the page number is being updated ('hatcheries', 'farms', or 'marketconnect').
    * @returns {void} This function does not return any value
    * Description:
    * This method is used to Handles the page change event by updating the active page number for the specified type.
    */
  public pageChange(pageNum: number, type: string): void {
    if (type == 'hatcheries') {
      this.hatcheryActivePageNo = pageNum;
    } else if (type == 'farms') {
      this.farmsActivePageNo = pageNum;
    } else if (type == 'marketconnect') {
      this.marketActivePageNo = pageNum;
    } else {
      this.buyerActivePageNo = pageNum;
    }
  }
}
